import React, { useEffect, useState } from 'react';
import Header from '../components/resuableComponents/Header';
import Footer from '../components/resuableComponents/Footer';
import { AutoComplete, Divider } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Container, Grid, FormControlLabel } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { DatePicker, Space } from 'antd';
import { Modal } from 'antd';
import type { DatePickerProps } from 'antd';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Skeleton from '@mui/material/Skeleton';
import { Button } from 'antd';
import {
	fetchCityDispatch,
	AddSearchFlightDispatch,
} from '../reducers/HomeReducer';
import { useLocation, useNavigate } from 'react-router-dom';
// import { DatePicker, Space } from 'antd';
import FlightResultSkeleton from '../components/resuableComponents/FlightResultSkeleton';
import FlightRoundTripSkeleton from '../components/resuableComponents/FlightRoundTripSkeleton';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {
	setSelectedOnwardFlight,
	setSelectedReturnFlight,
} from '../reducers/UiReducer';
import TopDrawer from '../components/resuableComponents/TopDrawer';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
const Option = AutoComplete.Option;
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
const { RangePicker } = DatePicker;
const fareType = ['Refundable', 'Non-Refundable'];
const stopType = ['Non-Stop', '1-Stop', '2+Stop'];

const SearchResultInternational = () => {
	const { onwardFlight, returnFlight } = useSelector((state) => state.ui);
	const { city } = useSelector((state) => state.home);
	const [draw, setDraw] = useState(false);
	const { tboflight, loading } = useSelector((state) => state.tbo);
	const [airlineS, setairlineS] = useState('');
	const [stop, setStop] = useState('');
	const [fare, setFare] = useState('');
	const { etravresult } = useSelector((state) => state.etrav);
	const { tjkresult } = useSelector((state) => state.tripjack);
	const dispatch = useDispatch();
	const [result, setResult] = useState([]);
	const [departDate, setDepartDate] = useState('');
	const [loadings, setLoading] = useState(false);
	const [open, setOpen] = useState(false);
	const [scrollVal, SetScrollVal] = useState(10);
	const [hasMorefilterData, SethasMoreFilterData] = useState(true);
	const navigate = useNavigate();
	const location = useLocation();
	console.log('location', location);
	const onChange: DatePickerProps['onChange'] = (date, dateString) => {
		console.log(date, dateString);
		setDepartDate(dateString);
	};
	const showModal = () => {
		setOpen(true);
	};

	const handleOk = () => {
		setLoading(true);
		setTimeout(() => {
			setLoading(false);
			setOpen(false);
		}, 3000);
	};

	const handleCancel = () => {
		setOpen(false);
	};
	const fetchMoreData = () => {
		// if (eltbo === fals && letrav === false && trp === false) {
		// 	if (scrollVal >= filterData.length) {
		// 		SethasMoreFilterData(false);
		// 	}
		// }

		setTimeout(() => {
			SetScrollVal(scrollVal + 5);
		}, 500);
	};
	const opsList =
		city?.result?.length > 0 &&
		city.result?.map((l) => {
			return (
				<Option
					value={`${l.airport_code} - ${l.city_name}`}>{`${l.airport_code} - ${l.city_name} , ${l.country_name}`}</Option>
			);
		});
	const handleAirline = (event) => {
		// SethasMoreResult(true);
		// SetScrollValResult(10);
		SetScrollVal(10);
		console.log('airline', event.target.name);
		setairlineS(event.target.name);
		if (airlineS === event.target.name) {
			setResult([]);
			setairlineS('');
		} else {
			let filterDataStop = [];
			let filterCombineStop = [];
			let tbo = [];
			if (tboflight) {
				tboflight &&
					tboflight &&
					tboflight.result &&
					tboflight.result.Response &&
					tboflight.result.Response.Results[0].length > 0 &&
					tboflight.result.Response.Results[0].map((item) => {
						if (
							item.Segments[0]?.[0]?.Airline.AirlineName === event.target.name
						) {
							tbo.push({
								...item,
							});
						}
					});
			}
			filterCombineStop = [...tbo];
			filterDataStop =
				filterCombineStop &&
				filterCombineStop.length > 0 &&
				filterCombineStop.slice().sort((a, b) => {
					let first = a.Fare
						? Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  )
						: a.Fares
						? Number(Math.round(a.Fares.Total_Amount))
						: a.totalPriceList
						? Number(Math.round(a.totalPriceList.fd.Total_Amount))
						: Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  );
					let second = b.Fare
						? Number(
								Number(Math.round(b.Fare.Total_Amount)) -
									Number(Math.round(b.Fare.MFB_Discount))
						  )
						: b.Fares
						? Number(Math.round(b.Fares.Total_Amount))
						: b.totalPriceList
						? Number(Math.round(b.totalPriceList.fd.Total_Amount))
						: Number(Math.round(b.Fare.Total_Amount)) -
						  Number(Math.round(b.Fare.MFB_Discount));
					return first - second;
				});
			setResult(filterDataStop);
			console.log('filterDataStop', filterDataStop);
			console.log('filterCombineStop', filterCombineStop);
		}
	};
	const handleStopType = (event) => {
		// SethasMoreResult(true);
		// SetScrollValResult(10);
		SetScrollVal(10);
		console.log('airline', event.target.name);
		setStop(event.target.name);
		if (stop === event.target.name) {
			setResult([]);
			setStop('');
		} else {
			let filterDataStop = [];
			let filterCombineStop = [];
			let tbo = [];
			if (tboflight) {
				tboflight &&
					tboflight.result &&
					tboflight.result.Response &&
					tboflight.result.Response.Results[0].length > 0 &&
					tboflight.result.Response.Results[0].map((item) => {
						if (
							event.target.name === 'Non-Stop'
								? item.Segments[0].length === 1
								: event.target.name === '1-Stop'
								? item.Segments[0].length === 1
								: item.Segments[0].length > 1
						) {
							tbo.push({
								...item,
							});
						}
					});
			}
			filterCombineStop = [...tbo];
			filterDataStop =
				filterCombineStop &&
				filterCombineStop.length > 0 &&
				filterCombineStop.slice().sort((a, b) => {
					let first = a.Fare
						? Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  )
						: a.Fares
						? Number(Math.round(a.Fares.Total_Amount))
						: a.totalPriceList
						? Number(Math.round(a.totalPriceList.fd.Total_Amount))
						: Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  );
					let second = b.Fare
						? Number(
								Number(Math.round(b.Fare.Total_Amount)) -
									Number(Math.round(b.Fare.MFB_Discount))
						  )
						: b.Fares
						? Number(Math.round(b.Fares.Total_Amount))
						: b.totalPriceList
						? Number(Math.round(b.totalPriceList.fd.Total_Amount))
						: Number(Math.round(b.Fare.Total_Amount)) -
						  Number(Math.round(b.Fare.MFB_Discount));
					return first - second;
				});
			setResult(filterDataStop);
			console.log('filterDataStop', filterDataStop);
			console.log('filterCombineStop', filterCombineStop);
		}
	};
	const handleFareType = (event) => {
		// SethasMoreResult(true);
		// SetScrollValResult(10);
		SetScrollVal(10);
		console.log('airline', event.target.name);
		setFare(event.target.name);
		if (fare === event.target.name) {
			setResult([]);
			setFare('');
		} else {
			let filterDataStop = [];
			let filterCombineStop = [];
			let tbo = [];
			if (tboflight) {
				tboflight &&
					tboflight.result &&
					tboflight.result.Response &&
					tboflight.result.Response.Results[0].length > 0 &&
					tboflight.result.Response.Results[0].map((item) => {
						if (
							event.target.name === 'Refundable'
								? item.IsRefundable
								: !item.IsRefundable
						) {
							tbo.push({
								...item,
							});
						}
					});
			}
			filterCombineStop = [...tbo];
			filterDataStop =
				filterCombineStop &&
				filterCombineStop.length > 0 &&
				filterCombineStop.slice().sort((a, b) => {
					let first = a.Fare
						? Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  )
						: a.Fares
						? Number(Math.round(a.Fares.Total_Amount))
						: a.totalPriceList
						? Number(Math.round(a.totalPriceList.fd.Total_Amount))
						: Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  );
					let second = b.Fare
						? Number(
								Number(Math.round(b.Fare.Total_Amount)) -
									Number(Math.round(b.Fare.MFB_Discount))
						  )
						: b.Fares
						? Number(Math.round(b.Fares.Total_Amount))
						: b.totalPriceList
						? Number(Math.round(b.totalPriceList.fd.Total_Amount))
						: Number(Math.round(b.Fare.Total_Amount)) -
						  Number(Math.round(b.Fare.MFB_Discount));
					return first - second;
				});
			setResult(filterDataStop);
			console.log('filterDataStop', filterDataStop);
			console.log('filterCombineStop', filterCombineStop);
		}
	};
	const handleChange = (value) => {
		let values = value.toLowerCase();
		let cityData = {
			keywords: values,
			limits: 10,
		};
		dispatch(fetchCityDispatch(cityData));
	};
	console.log('etravresult', etravresult);
	useEffect(() => {
		dispatch(AddSearchFlightDispatch(location.state));
	}, []);
	let combo = [];
	let combineflightData = [];
	let filterData = [];
	let filterAirlineTBO = [];
	let filterAirlineTBO2 = [];
	let filterAirlineCom = [];

	if (loading) {
		console.log('Loading');
	} else {
		let tbo =
			tboflight &&
			tboflight?.result &&
			tboflight?.result?.Response &&
			tboflight?.result?.Response?.Results[0].length > 0 &&
			tboflight?.result?.Response?.Results[0];
		let etrav =
			etravresult &&
			etravresult?.result &&
			etravresult?.result?.TripDetails[0]?.Flights;
		let tjk =
			tjkresult &&
			tjkresult?.result?.searchResult &&
			tjkresult?.result?.searchResult?.tripInfos.COMBO.length > 0 &&
			tjkresult?.result?.searchResult?.tripInfos.COMBO;
		console.log('tjk', tjk);
		if (tbo?.length > 0 && etrav?.length > 0 && tjk?.length > 0) {
			combineflightData = [...tbo, ...etrav, ...tjk];
		} else if (tbo?.length > 0 && etrav?.length > 0) {
			combineflightData = [...tbo, ...etrav];
		} else if (tbo?.length > 0 && tjk?.length > 0) {
			combineflightData = [...tbo, ...tjk];
		} else if (etrav?.length > 0 && tjk?.length > 0) {
			combineflightData = [...etrav, ...tjk];
		} else if (etrav?.length > 0 && tbo?.length > 0) {
			combineflightData = [...etrav, ...tbo];
		} else if (tbo?.length > 0) {
			combineflightData = [...tbo];
		} else if (etrav?.length > 0) {
			combineflightData = [...etrav];
		} else if (tjk?.length > 0) {
			combineflightData = [...tjk];
		}
		filterData =
			combineflightData &&
			combineflightData.length > 0 &&
			combineflightData.slice().sort((a, b) => {
				let first =
					a.Supplier === 'TBO'
						? Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  )
						: a.Supplier === 'ETR'
						? Number(Math.round(a.Fares.Total_Amount))
						: a.Supplier === 'TJK'
						? Number(Math.round(a.totalPriceList.fd.Total_Amount))
						: '';
				let second =
					b.Supplier === 'TBO'
						? Number(
								Number(Math.round(b.Fare.Total_Amount)) -
									Number(Math.round(b.Fare.MFB_Discount))
						  )
						: b.Supplier === 'ETR'
						? Number(Math.round(b.Fares.Total_Amount))
						: b.Supplier === 'TJK'
						? Number(Math.round(b.totalPriceList.fd.Total_Amount))
						: '';
				return first - second;
			});
		filterAirlineTBO = [
			...new Set(
				tboflight &&
					tboflight?.result &&
					tboflight?.result?.Response &&
					tboflight?.result?.Response?.Results[0].length > 0 &&
					tboflight?.result?.Response?.Results[0].map(
						(item) => item.Segments[0]?.[0]?.Airline.AirlineName
					)
			),
		];
	}
	let combineflightData2 = [];
	let filterData2 = [];
	console.log('filterDataAA', filterData);
	if (loading) {
		console.log('Loading');
	} else {
		let tbo =
			tboflight &&
			tboflight?.result &&
			tboflight?.result?.Response &&
			tboflight?.result?.Response?.Results[1]?.length > 0 &&
			tboflight?.result?.Response?.Results[1];
		let etrav =
			etravresult &&
			etravresult?.result &&
			etravresult?.result?.TripDetails[1]?.Flights;
		let tjk =
			tjkresult &&
			tjkresult?.result?.searchResult &&
			tjkresult?.result?.searchResult?.tripInfos?.COMBO?.length > 0 &&
			tjkresult?.result?.searchResult?.tripInfos?.COMBO;
		if (tbo?.length > 0 && etrav?.length > 0 && tjk?.length > 0) {
			combineflightData2 = [...tbo, ...etrav, ...tjk];
		} else if (tbo?.length > 0 && etrav?.length > 0) {
			combineflightData2 = [...tbo, ...etrav];
		} else if (tbo?.length > 0 && tjk?.length > 0) {
			combineflightData2 = [...tbo, ...tjk];
		} else if (etrav?.length > 0 && tjk?.length > 0) {
			combineflightData2 = [...etrav, ...tjk];
		} else if (etrav?.length > 0 && tbo?.length > 0) {
			combineflightData2 = [...etrav, ...tbo];
		} else if (tbo?.length > 0) {
			combineflightData2 = [...tbo];
		} else if (etrav?.length > 0) {
			combineflightData2 = [...etrav];
		} else if (tjk?.length > 0) {
			combineflightData2 = [...tjk];
		}
		filterData2 =
			combineflightData2 &&
			combineflightData2.length > 0 &&
			combineflightData2.slice().sort((a, b) => {
				let first =
					a.Supplier === 'TBO'
						? Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  )
						: a.Supplier === 'ETR'
						? Number(Math.round(a.Fares.Total_Amount))
						: a.Supplier === 'TJK'
						? Number(Math.round(a.totalPriceList.fd.Total_Amount))
						: '';
				let second =
					b.Supplier === 'TBO'
						? Number(
								Number(Math.round(b.Fare.Total_Amount)) -
									Number(Math.round(b.Fare.MFB_Discount))
						  )
						: b.Supplier === 'ETR'
						? Number(Math.round(b.Fares.Total_Amount))
						: b.Supplier === 'TJK'
						? Number(Math.round(b.totalPriceList.fd.Total_Amount))
						: '';
				return first - second;
			});
		filterAirlineTBO2 = [
			...new Set(
				tboflight &&
					tboflight?.result &&
					tboflight?.result?.Response &&
					tboflight?.result?.Response?.Results[0].length > 0 &&
					tboflight?.result?.Response?.Results[0].map(
						(item) => item.Segments[0]?.[0]?.Airline.AirlineName
					)
			),
		];
	}
	combo = [filterData, filterData2];
	filterAirlineCom = [...filterAirlineTBO, ...filterAirlineTBO2];
	console.log('FilterData', combo);
	return (
		<div>
			<Navbar />
			<Box style={{ background: '#721053' }}>
				<Box
					style={{
						paddingLeft: 100,
						paddingRight: 100,
						paddingTop: 15,
						paddingBottom: 15,
					}}>
					<Grid container spacing={2}>
						<Grid item xs={3}>
							<AutoComplete
								style={{ width: '100%', borderRadius: 2 }}
								dropdownMenuStyle={{
									maxHeight: 1000,
									overflowY: 'visible',
									maxWidth: 500,
								}}
								placeholder='From'
								onChange={handleChange}>
								{opsList}
							</AutoComplete>
						</Grid>
						<Grid item xs={3}>
							<AutoComplete
								style={{ width: '100%', borderRadius: 2 }}
								dropdownMenuStyle={{
									maxHeight: 1000,
									overflowY: 'visible',
									maxWidth: 500,
								}}
								placeholder='From'
								onChange={handleChange}>
								{opsList}
							</AutoComplete>
						</Grid>
						<Grid item xs={3}>
							{/* <DatePicker
								onChange={onChange}
								style={{ width: '100%', padding: 8 }}
							/> */}
							<RangePicker style={{ width: '100%', padding: 8 }} />
						</Grid>{' '}
						<Grid item xs={2}>
							<Button
								onClick={showModal}
								style={{
									textTransform: 'capitalize',
									padding: 7,
									border: '1px solid lightgrey',
									width: '100%',
									height: 'auto',
									color: 'white',
								}}>
								Traveller Class
							</Button>{' '}
							<Modal
								open={open}
								title='Travellers'
								onOk={handleOk}
								onCancel={handleCancel}
								footer={[
									<Button key='back' onClick={handleCancel}>
										OK
									</Button>,
								]}>
								<Box
									style={{
										display: 'flex',
										justifyContent: 'space-between',
									}}>
									<p>Adults(12+yrs)</p>
									<Box>
										<Button
											style={{
												fontSize: 14,
												background: 'orange',
												color: 'white',
											}}>
											--
										</Button>
										<Button
											style={{
												fontSize: 14,
												background: 'white',
											}}>
											5
										</Button>
										<Button
											style={{
												fontSize: 14,
												background: 'orange',
												color: 'white',
											}}>
											+
										</Button>
									</Box>
								</Box>
								<Box
									style={{
										display: 'flex',
										justifyContent: 'space-between',
									}}>
									<p>Child(2-11yrs)</p>
									<Box>
										<Button
											style={{
												fontSize: 14,
												background: 'orange',
												color: 'white',
											}}>
											--
										</Button>
										<Button
											style={{
												fontSize: 14,
												background: 'white',
											}}>
											5
										</Button>
										<Button
											style={{
												fontSize: 14,
												background: 'orange',
												color: 'white',
											}}>
											+
										</Button>
									</Box>
								</Box>
								<Box
									style={{
										display: 'flex',
										justifyContent: 'space-between',
									}}>
									<p>Infant(0-2yrs)</p>
									<Box>
										<Button
											style={{
												fontSize: 14,
												background: 'orange',
												color: 'white',
											}}>
											--
										</Button>
										<Button
											style={{
												fontSize: 14,
												background: 'white',
											}}>
											5
										</Button>
										<Button
											style={{
												fontSize: 14,
												background: 'orange',
												color: 'white',
											}}>
											+
										</Button>
									</Box>
								</Box>
							</Modal>
						</Grid>
						<Grid item xs={1}>
							<Button
								style={{
									background: '#EC5B24',
									color: 'white',
									width: '100%',
									padding: 7,
									height: 'auto',
								}}>
								Search
							</Button>
						</Grid>
					</Grid>
				</Box>
			</Box>
			<Box
				style={{
					background: '#FFF',
					boxShadow: '0 0 10px rgba(0,0,0,.3)',
					paddingLeft: 100,
					paddingRight: 100,
					paddingTop: 10,
				}}>
				<Grid container spacing={2}>
					<Grid item xs={3}>
						<Box>
							<span>Stops</span>
						</Box>
						<Box style={{ display: 'flex', flexWrap: 'wrap' }}>
							{stopType &&
								stopType.length > 0 &&
								stopType.map((i, index) => {
									return (
										<FormControlLabel
											control={
												<Checkbox
													checked={stop === i ? true : false}
													onChange={handleStopType}
													name={`${i}`}
													sx={{}}
												/>
											}
											label={
												<>
													<span style={{ fontSize: 12 }}>{i}</span>
												</>
											}
										/>
									);
								})}
						</Box>
					</Grid>
					<Grid item xs={4}>
						<Box>
							<span>Airline</span>
						</Box>
						<Box style={{ display: 'flex', flexWrap: 'wrap' }}>
							{filterAirlineCom &&
								filterAirlineCom.length > 0 &&
								filterAirlineCom.map((i, index) => {
									return index < 4 ? (
										<FormControlLabel
											control={
												<Checkbox
													checked={airlineS === i ? true : false}
													onChange={handleAirline}
													name={`${i}`}
													sx={{}}
												/>
											}
											label={
												<>
													<span style={{ fontSize: 12 }}>{i}</span>
												</>
											}
										/>
									) : (
										''
									);
								})}
						</Box>
					</Grid>
					<Grid item xs={3}>
						<Box>
							<span>Fare Type</span>
						</Box>
						<Box style={{ display: 'flex', flexWrap: 'wrap' }}>
							{fareType &&
								fareType.length > 0 &&
								fareType.map((i, index) => {
									return (
										<FormControlLabel
											control={
												<Checkbox
													checked={fare === i ? true : false}
													onChange={handleFareType}
													name={`${i}`}
													sx={{}}
												/>
											}
											label={
												<>
													<span style={{ fontSize: 12 }}>{i}</span>
												</>
											}
										/>
									);
								})}
						</Box>
					</Grid>
					<Grid item xs={2}>
						<Box
							style={{
								display: 'flex',
								alignItems: 'center',
								cursor: 'pointer',
							}}
							onClick={() => setDraw(true)}>
							More <i class='fa fa-angle-down' style={{ marginLeft: 5 }}></i>
						</Box>
					</Grid>
				</Grid>
			</Box>
			<Box
				style={{
					marginTop: 50,
					marginBottom: 50,
					paddingLeft: 100,
					paddingRight: 100,
				}}>
				<Grid container spacing={4}>
					<Grid item xs={8}>
						{result ? (
							result?.length > 0 ? (
								<InfiniteScroll
									dataLength={scrollVal}
									next={fetchMoreData}
									hasMore={hasMorefilterData}
									loader={<h4 style={{ textAlign: 'center' }}>Loading...</h4>}
									endMessage={
										<p style={{ textAlign: 'center' }}>
											<b>No More Flights</b>
										</p>
									}>
									{result.map((item, index) => {
										return index < scrollVal ? (
											<>
												<Grid
													onClick={() =>
														dispatch(setSelectedOnwardFlight(item))
													}
													container
													spacing={2}
													style={{
														background:
															item?.Supplier === 'TBO'
																? item?.ResultIndex ===
																  onwardFlight?.ResultIndex
																	? '#f0f0f0'
																	: '#fff'
																: '',
														filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, .25))',
														marginTop: 10,
													}}>
													<Grid item xs={6}>
														<Box
															style={{
																display: 'flex',
																justifyContent: 'space-between',
																alignItems: 'center',
																borderRadius: 4,
																padding: 30,
																marginTop: 10,
																cursor: 'pointer',
															}}>
															<Box>
																<img
																	src={`https://nitish.musafirbazar.com/static/media/${
																		item.Supplier === 'TBO'
																			? item.AirlineCode
																			: item.Supplier === 'ETR'
																			? item.Airline_Code
																			: item.Supplier === 'TJK'
																			? item.sI[0].fD.aI.code
																			: ''
																	}.gif`}
																	style={{ height: 25 }}
																/>
																<br></br>
																<span
																	style={{
																		color: 'rgba(0,0,0,.38)',
																		fontSize: 12,
																	}}>
																	{item.Supplier === 'TBO'
																		? item.Segments[0].slice(0, 1).map((i) => {
																				return i.Airline.AirlineName;
																		  })
																		: item.Supplier === 'ETR'
																		? item.Segments[0].Airline_Name
																		: item.Supplier === 'TJK'
																		? item.sI[0].fD.aI.name
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		color: 'rgba(0,0,0,.38)',
																		fontSize: 12,
																	}}>
																	{`${
																		item.Supplier === 'TBO'
																			? item.AirlineCode
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Airline_Code
																			: item.Supplier === 'TJK'
																			? item.sI[0].fD.aI.code
																			: ''
																	}${
																		item.Supplier === 'TBO'
																			? item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Airline.FlightNumber;
																					})
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Flight_Number
																			: item.Supplier === 'TJK'
																			? item.sI[0].fD.fN
																			: ''
																	}`}
																</span>
															</Box>

															<Box>
																<span
																	style={{
																		fontSize: 14,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	{item.Supplier === 'TBO'
																		? item.FareRules[0].Origin
																		: item.Supplier === 'ETR'
																		? item.Origin
																		: item.Supplier === 'TJK'
																		? item.sI[0].da.code
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		fontSize: 20,
																	}}>
																	{item.Supplier === 'TBO'
																		? item.Segments[0].slice(0, 1).map((i) => {
																				return i.Origin.DepTime.substr(11, 5);
																		  })
																		: item.Supplier === 'ETR'
																		? item.Segments[0].Departure_DateTime.split(
																				' '
																		  )[1]
																		: item.Supplier === 'TJK'
																		? item.sI[0].dt.substr(11, 5)
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		fontSize: 12,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	{`${new Date(
																		item.Supplier === 'TBO'
																			? item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Origin.DepTime.split(
																							'T'
																						)[0];
																					})
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Departure_DateTime.split(
																					' '
																			  )[0]
																			: item.Supplier === 'TJK'
																			? item.sI[0].dt.split('T')[0]
																			: ''
																	).toLocaleString('en-us', {
																		weekday: 'short',
																	})} ,  ${new Date(
																		item.Supplier === 'TBO'
																			? item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Origin.DepTime.split(
																							'T'
																						)[0];
																					})
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Departure_DateTime.split(
																					' '
																			  )[0]
																			: item.Supplier === 'TJK'
																			? item.sI[0].dt.split('T')[0]
																			: ''
																	).getDate()} ${new Date(
																		item.Supplier === 'TBO'
																			? item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Origin.DepTime.split(
																							'T'
																						)[0];
																					})
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Departure_DateTime.split(
																					' '
																			  )[0]
																			: item.Supplier === 'TJK'
																			? item.sI[0].dt.split('T')[0]
																			: ''
																	).toLocaleString('en-us', {
																		month: 'short',
																	})}`}
																</span>
																<br></br>
															</Box>
															<Box textAlign={'center'}>
																<span
																	style={{
																		fontSize: 14,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	2hr 15min
																</span>
																<br></br>
																<span>-----------</span>
																<br></br>

																<span
																	style={{
																		fontSize: 12,
																	}}>
																	{item.Supplier === 'TBO'
																		? item.Segments[0].length === 1
																			? 'Non Stop'
																			: item.Segments[0].length === 2
																			? '1 Stop'
																			: item.Segments[0].length === 3
																			? '2 Stop'
																			: ''
																		: item.Supplier === 'ETR'
																		? item.Segments.length === 1
																			? 'Non Stop'
																			: item.Segments.length === 2
																			? '1 Stop'
																			: item.Segments.length === 3
																			? '2 Stop'
																			: ''
																		: item.Supplier === 'TJK'
																		? item.sI.length === 1
																			? 'Non Stop'
																			: item.sI.length === 2
																			? '1 Stop'
																			: item.sI.length === 3
																			? '2 Stop'
																			: ''
																		: ''}
																</span>
															</Box>
															<Box>
																<span
																	style={{
																		fontSize: 14,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	{item.Supplier === 'TBO'
																		? item.Segments[0].length == 2
																			? item.Segments[0]
																					.filter((i, index) => index === 1)
																					.map((it) => {
																						return it.Destination.Airport
																							.AirportCode;
																					})
																			: item.Segments[0].length == 3
																			? item.Segments[0]
																					.filter((i, index) => index === 2)
																					.map((it) => {
																						return it.Destination.Airport
																							.AirportCode;
																					})
																			: item.Segments[0].length == 1
																			? item.Segments[0].map((it) => {
																					return it.Destination.Airport
																						.AirportCode;
																			  })
																			: ''
																		: item.Supplier === 'ETR'
																		? item.Destination
																		: item.Supplier === 'TJK'
																		? item.sI.length === 1
																			? item.sI
																					.filter((i, index) => index === 0)
																					.map((it) => {
																						return it.aa.cityCode;
																					})
																			: item.sI.length === 2
																			? item.sI
																					.filter((i, index) => index === 1)
																					.map((it) => {
																						return it.aa.cityCode;
																					})
																			: item.sI.length === 3
																			? item.sI
																					.filter((i, index) => index === 2)
																					.map((it) => {
																						return it.aa.cityCode;
																					})
																			: ''
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		fontSize: 20,
																	}}>
																	{item.AirlineCode
																		? item.Segments[0].length == 3
																			? item.Segments[0]
																					.filter((i, index) => index === 2)
																					.map((i) => {
																						return i.Destination.ArrTime.substr(
																							11,
																							5
																						);
																					})
																			: item.Segments[0].length == 2
																			? item.Segments[0]
																					.filter((i, index) => index === 1)
																					.map((i) => {
																						return i.Destination.ArrTime.substr(
																							11,
																							5
																						);
																					})
																			: item.Segments[0].length == 1
																			? item.Segments[0]
																					.filter((i, index) => index === 0)
																					.map((i) => {
																						return i.Destination.ArrTime.substr(
																							11,
																							5
																						);
																					})
																			: ''
																		: item.Supplier === 'ETR'
																		? item.Segments.length === 1
																			? item.Segments.filter(
																					(i, index) => index === 0
																			  ).map((it) => {
																					return it.Arrival_DateTime.substr(
																						11,
																						5
																					);
																			  })
																			: item.Segments.length === 2
																			? item.Segments.filter(
																					(i, index) => index === 1
																			  ).map((it) => {
																					return it.Arrival_DateTime.substr(
																						11,
																						5
																					);
																			  })
																			: item.Segments.length === 3
																			? item.Segments.filter(
																					(i, index) => index === 2
																			  ).map((it) => {
																					return it.Arrival_DateTime.substr(
																						11,
																						5
																					);
																			  })
																			: ''
																		: item.Supplier === 'TJK'
																		? item.sI.length === 1
																			? item.sI
																					.filter((i, index) => index === 0)
																					.map((it) => {
																						return it.at.substr(11, 5);
																					})
																			: item.sI.length === 2
																			? item.sI
																					.filter((i, index) => index === 1)
																					.map((it) => {
																						return it.at.substr(11, 5);
																					})
																			: item.sI.length === 3
																			? item.sI
																					.filter((i, index) => index === 2)
																					.map((it) => {
																						return it.at.substr(11, 5);
																					})
																			: ''
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		fontSize: 12,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	{`${new Date(
																		item.AirlineCode
																			? item.Segments[0].length == 3
																				? item.Segments[0]
																						.filter((i, index) => index === 2)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[0].length == 2
																				? item.Segments[0]
																						.filter((i, index) => index === 1)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[0].length == 1
																				? item.Segments[0]
																						.filter((i, index) => index === 0)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: ''
																			: item.Supplier === 'ETR'
																			? item.Segments.length === 1
																				? item.Segments.filter(
																						(i, index) => index === 0
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 2
																				? item.Segments.filter(
																						(i, index) => index === 1
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 3
																				? item.Segments.filter(
																						(i, index) => index === 2
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: ''
																			: item.Supplier === 'TJK'
																			? item.sI.length === 1
																				? item.sI
																						.filter((i, index) => index === 0)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 2
																				? item.sI
																						.filter((i, index) => index === 1)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 3
																				? item.sI
																						.filter((i, index) => index === 2)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: ''
																			: ''
																	).toLocaleString('en-us', {
																		weekday: 'short',
																	})} ,  ${new Date(
																		item.AirlineCode
																			? item.Segments[0].length == 3
																				? item.Segments[0]
																						.filter((i, index) => index === 2)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[0].length == 2
																				? item.Segments[0]
																						.filter((i, index) => index === 1)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[0].length == 1
																				? item.Segments[0]
																						.filter((i, index) => index === 0)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: ''
																			: item.Supplier === 'ETR'
																			? item.Segments.length === 1
																				? item.Segments.filter(
																						(i, index) => index === 0
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 2
																				? item.Segments.filter(
																						(i, index) => index === 1
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 3
																				? item.Segments.filter(
																						(i, index) => index === 2
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: ''
																			: item.Supplier === 'TJK'
																			? item.sI.length === 1
																				? item.sI
																						.filter((i, index) => index === 0)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 2
																				? item.sI
																						.filter((i, index) => index === 1)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 3
																				? item.sI
																						.filter((i, index) => index === 2)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: ''
																			: ''
																	).getDate()} ${new Date(
																		item.AirlineCode
																			? item.Segments[0].length == 3
																				? item.Segments[0]
																						.filter((i, index) => index === 2)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[0].length == 2
																				? item.Segments[0]
																						.filter((i, index) => index === 1)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[0].length == 1
																				? item.Segments[0]
																						.filter((i, index) => index === 0)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: ''
																			: item.Supplier === 'ETR'
																			? item.Segments.length === 1
																				? item.Segments.filter(
																						(i, index) => index === 0
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 2
																				? item.Segments.filter(
																						(i, index) => index === 1
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 3
																				? item.Segments.filter(
																						(i, index) => index === 2
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: ''
																			: item.Supplier === 'TJK'
																			? item.sI.length === 1
																				? item.sI
																						.filter((i, index) => index === 0)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 2
																				? item.sI
																						.filter((i, index) => index === 1)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 3
																				? item.sI
																						.filter((i, index) => index === 2)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: ''
																			: ''
																	).toLocaleString('en-us', {
																		month: 'short',
																	})}`}
																</span>
															</Box>
														</Box>
													</Grid>
													<Grid item xs={6}>
														<Box
															style={{
																display: 'flex',
																justifyContent: 'space-between',
																alignItems: 'center',
																borderRadius: 4,
																padding: 30,
																cursor: 'pointer',
																marginTop: 10,
															}}>
															<Box>
																<img
																	src={`https://nitish.musafirbazar.com/static/media/${
																		item.Supplier === 'TBO'
																			? item.AirlineCode
																			: item.Supplier === 'ETR'
																			? item.Airline_Code
																			: item.Supplier === 'TJK'
																			? item.sI[0].fD.aI.code
																			: ''
																	}.gif`}
																	style={{ height: 25 }}
																/>
																<br></br>
																<span
																	style={{
																		color: 'rgba(0,0,0,.38)',
																		fontSize: 12,
																	}}>
																	{item.Supplier === 'TBO'
																		? item.Segments[1].slice(0, 1).map((i) => {
																				return i.Airline.AirlineName;
																		  })
																		: item.Supplier === 'ETR'
																		? item.Segments[0].Airline_Name
																		: item.Supplier === 'TJK'
																		? item.sI[0].fD.aI.name
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		color: 'rgba(0,0,0,.38)',
																		fontSize: 12,
																	}}>
																	{`${
																		item.Supplier === 'TBO'
																			? item.AirlineCode
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Airline_Code
																			: item.Supplier === 'TJK'
																			? item.sI[0].fD.aI.code
																			: ''
																	}${
																		item.Supplier === 'TBO'
																			? item.Segments[1]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Airline.FlightNumber;
																					})
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Flight_Number
																			: item.Supplier === 'TJK'
																			? item.sI[0].fD.fN
																			: ''
																	}`}
																</span>
															</Box>

															<Box>
																<span
																	style={{
																		fontSize: 14,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	{item.Supplier === 'TBO'
																		? item.FareRules[1].Origin
																		: item.Supplier === 'ETR'
																		? item.Origin
																		: item.Supplier === 'TJK'
																		? item.sI[0].da.code
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		fontSize: 20,
																	}}>
																	{item.Supplier === 'TBO'
																		? item.Segments[1].slice(0, 1).map((i) => {
																				return i.Origin.DepTime.substr(11, 5);
																		  })
																		: item.Supplier === 'ETR'
																		? item.Segments[0].Departure_DateTime.split(
																				' '
																		  )[1]
																		: item.Supplier === 'TJK'
																		? item.sI[0].dt.substr(11, 5)
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		fontSize: 12,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	{`${new Date(
																		item.Supplier === 'TBO'
																			? item.Segments[1]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Origin.DepTime.split(
																							'T'
																						)[0];
																					})
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Departure_DateTime.split(
																					' '
																			  )[0]
																			: item.Supplier === 'TJK'
																			? item.sI[0].dt.split('T')[0]
																			: ''
																	).toLocaleString('en-us', {
																		weekday: 'short',
																	})} ,  ${new Date(
																		item.Supplier === 'TBO'
																			? item.Segments[1]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Origin.DepTime.split(
																							'T'
																						)[0];
																					})
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Departure_DateTime.split(
																					' '
																			  )[0]
																			: item.Supplier === 'TJK'
																			? item.sI[0].dt.split('T')[0]
																			: ''
																	).getDate()} ${new Date(
																		item.Supplier === 'TBO'
																			? item.Segments[1]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Origin.DepTime.split(
																							'T'
																						)[0];
																					})
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Departure_DateTime.split(
																					' '
																			  )[0]
																			: item.Supplier === 'TJK'
																			? item.sI[0].dt.split('T')[0]
																			: ''
																	).toLocaleString('en-us', {
																		month: 'short',
																	})}`}
																</span>
																<br></br>
															</Box>
															<Box textAlign={'center'}>
																<span
																	style={{
																		fontSize: 14,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	2hr 15min
																</span>
																<br></br>
																<span>-----------</span>
																<br></br>

																<span
																	style={{
																		fontSize: 12,
																	}}>
																	{item.Supplier === 'TBO'
																		? item.Segments[1].length === 1
																			? 'Non Stop'
																			: item.Segments[1].length === 2
																			? '1 Stop'
																			: item.Segments[1].length === 3
																			? '2 Stop'
																			: ''
																		: item.Supplier === 'ETR'
																		? item.Segments.length === 1
																			? 'Non Stop'
																			: item.Segments.length === 2
																			? '1 Stop'
																			: item.Segments.length === 3
																			? '2 Stop'
																			: ''
																		: item.Supplier === 'TJK'
																		? item.sI.length === 1
																			? 'Non Stop'
																			: item.sI.length === 2
																			? '1 Stop'
																			: item.sI.length === 3
																			? '2 Stop'
																			: ''
																		: ''}
																</span>
															</Box>
															<Box>
																<span
																	style={{
																		fontSize: 14,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	{item.Supplier === 'TBO'
																		? item.Segments[1].length == 2
																			? item.Segments[1]
																					.filter((i, index) => index === 1)
																					.map((it) => {
																						return it.Destination.Airport
																							.AirportCode;
																					})
																			: item.Segments[1].length == 3
																			? item.Segments[1]
																					.filter((i, index) => index === 2)
																					.map((it) => {
																						return it.Destination.Airport
																							.AirportCode;
																					})
																			: item.Segments[1].length == 1
																			? item.Segments[1].map((it) => {
																					return it.Destination.Airport
																						.AirportCode;
																			  })
																			: ''
																		: item.Supplier === 'ETR'
																		? item.Destination
																		: item.Supplier === 'TJK'
																		? item.sI.length === 1
																			? item.sI
																					.filter((i, index) => index === 0)
																					.map((it) => {
																						return it.aa.cityCode;
																					})
																			: item.sI.length === 2
																			? item.sI
																					.filter((i, index) => index === 1)
																					.map((it) => {
																						return it.aa.cityCode;
																					})
																			: item.sI.length === 3
																			? item.sI
																					.filter((i, index) => index === 2)
																					.map((it) => {
																						return it.aa.cityCode;
																					})
																			: ''
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		fontSize: 20,
																	}}>
																	{item.AirlineCode
																		? item.Segments[1].length == 3
																			? item.Segments[1]
																					.filter((i, index) => index === 2)
																					.map((i) => {
																						return i.Destination.ArrTime.substr(
																							11,
																							5
																						);
																					})
																			: item.Segments[1].length == 2
																			? item.Segments[1]
																					.filter((i, index) => index === 1)
																					.map((i) => {
																						return i.Destination.ArrTime.substr(
																							11,
																							5
																						);
																					})
																			: item.Segments[1].length == 1
																			? item.Segments[1]
																					.filter((i, index) => index === 0)
																					.map((i) => {
																						return i.Destination.ArrTime.substr(
																							11,
																							5
																						);
																					})
																			: ''
																		: item.Supplier === 'ETR'
																		? item.Segments.length === 1
																			? item.Segments.filter(
																					(i, index) => index === 0
																			  ).map((it) => {
																					return it.Arrival_DateTime.substr(
																						11,
																						5
																					);
																			  })
																			: item.Segments.length === 2
																			? item.Segments.filter(
																					(i, index) => index === 1
																			  ).map((it) => {
																					return it.Arrival_DateTime.substr(
																						11,
																						5
																					);
																			  })
																			: item.Segments.length === 3
																			? item.Segments.filter(
																					(i, index) => index === 2
																			  ).map((it) => {
																					return it.Arrival_DateTime.substr(
																						11,
																						5
																					);
																			  })
																			: ''
																		: item.Supplier === 'TJK'
																		? item.sI.length === 1
																			? item.sI
																					.filter((i, index) => index === 0)
																					.map((it) => {
																						return it.at.substr(11, 5);
																					})
																			: item.sI.length === 2
																			? item.sI
																					.filter((i, index) => index === 1)
																					.map((it) => {
																						return it.at.substr(11, 5);
																					})
																			: item.sI.length === 3
																			? item.sI
																					.filter((i, index) => index === 2)
																					.map((it) => {
																						return it.at.substr(11, 5);
																					})
																			: ''
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		fontSize: 12,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	{`${new Date(
																		item.AirlineCode
																			? item.Segments[1].length == 3
																				? item.Segments[1]
																						.filter((i, index) => index === 2)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[1].length == 2
																				? item.Segments[1]
																						.filter((i, index) => index === 1)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[1].length == 1
																				? item.Segments[1]
																						.filter((i, index) => index === 0)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: ''
																			: item.Supplier === 'ETR'
																			? item.Segments.length === 1
																				? item.Segments.filter(
																						(i, index) => index === 0
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 2
																				? item.Segments.filter(
																						(i, index) => index === 1
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 3
																				? item.Segments.filter(
																						(i, index) => index === 2
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: ''
																			: item.Supplier === 'TJK'
																			? item.sI.length === 1
																				? item.sI
																						.filter((i, index) => index === 0)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 2
																				? item.sI
																						.filter((i, index) => index === 1)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 3
																				? item.sI
																						.filter((i, index) => index === 2)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: ''
																			: ''
																	).toLocaleString('en-us', {
																		weekday: 'short',
																	})} ,  ${new Date(
																		item.AirlineCode
																			? item.Segments[1].length == 3
																				? item.Segments[1]
																						.filter((i, index) => index === 2)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[1].length == 2
																				? item.Segments[1]
																						.filter((i, index) => index === 1)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[1].length == 1
																				? item.Segments[1]
																						.filter((i, index) => index === 0)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: ''
																			: item.Supplier === 'ETR'
																			? item.Segments.length === 1
																				? item.Segments.filter(
																						(i, index) => index === 0
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 2
																				? item.Segments.filter(
																						(i, index) => index === 1
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 3
																				? item.Segments.filter(
																						(i, index) => index === 2
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: ''
																			: item.Supplier === 'TJK'
																			? item.sI.length === 1
																				? item.sI
																						.filter((i, index) => index === 0)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 2
																				? item.sI
																						.filter((i, index) => index === 1)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 3
																				? item.sI
																						.filter((i, index) => index === 2)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: ''
																			: ''
																	).getDate()} ${new Date(
																		item.AirlineCode
																			? item.Segments[1].length == 3
																				? item.Segments[1]
																						.filter((i, index) => index === 2)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[1].length == 2
																				? item.Segments[1]
																						.filter((i, index) => index === 1)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[1].length == 1
																				? item.Segments[1]
																						.filter((i, index) => index === 0)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: ''
																			: item.Supplier === 'ETR'
																			? item.Segments.length === 1
																				? item.Segments.filter(
																						(i, index) => index === 0
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 2
																				? item.Segments.filter(
																						(i, index) => index === 1
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 3
																				? item.Segments.filter(
																						(i, index) => index === 2
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: ''
																			: item.Supplier === 'TJK'
																			? item.sI.length === 1
																				? item.sI
																						.filter((i, index) => index === 0)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 2
																				? item.sI
																						.filter((i, index) => index === 1)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 3
																				? item.sI
																						.filter((i, index) => index === 2)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: ''
																			: ''
																	).toLocaleString('en-us', {
																		month: 'short',
																	})}`}
																</span>
															</Box>
															<h4>
																₹
																{item.Supplier === 'TBO'
																	? Number(
																			Math.round(
																				Number(
																					Number(
																						Math.round(item.Fare.Total_Amount)
																					) -
																						Number(
																							Math.round(item.Fare.MFB_Discount)
																						)
																				)
																			)
																	  )
																	: item.Supplier === 'ETR'
																	? Number(
																			Math.round(
																				Number(
																					Number(
																						Math.round(item.Fares.Total_Amount)
																					)
																				)
																			)
																	  )
																	: item.Supplier === 'TJK'
																	? Number(
																			Math.round(
																				Number(
																					Number(
																						Math.round(
																							item.totalPriceList.fd
																								.Total_Amount
																						)
																					)
																				)
																			)
																	  )
																	: ''}
															</h4>
														</Box>
													</Grid>
												</Grid>
											</>
										) : (
											''
										);
									})}
								</InfiniteScroll>
							) : filterData?.length > 0 ? (
								<InfiniteScroll
									dataLength={scrollVal}
									next={fetchMoreData}
									hasMore={hasMorefilterData}
									loader={<h4 style={{ textAlign: 'center' }}>Loading...</h4>}
									endMessage={
										<p style={{ textAlign: 'center' }}>
											<b>No More Flights</b>
										</p>
									}>
									{filterData.map((item, index) => {
										return index < scrollVal ? (
											<>
												<Grid
													onClick={() =>
														dispatch(setSelectedOnwardFlight(item))
													}
													container
													spacing={2}
													style={{
														background:
															item?.Supplier === 'TBO'
																? item?.ResultIndex ===
																  onwardFlight?.ResultIndex
																	? '#f0f0f0'
																	: '#fff'
																: '',
														filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, .25))',
														marginTop: 10,
													}}>
													<Grid item xs={6}>
														<Box
															style={{
																display: 'flex',
																justifyContent: 'space-between',
																alignItems: 'center',
																borderRadius: 4,
																padding: 30,
																marginTop: 10,
																cursor: 'pointer',
															}}>
															<Box>
																<img
																	src={`https://nitish.musafirbazar.com/static/media/${
																		item.Supplier === 'TBO'
																			? item.AirlineCode
																			: item.Supplier === 'ETR'
																			? item.Airline_Code
																			: item.Supplier === 'TJK'
																			? item.sI[0].fD.aI.code
																			: ''
																	}.gif`}
																	style={{ height: 25 }}
																/>
																<br></br>
																<span
																	style={{
																		color: 'rgba(0,0,0,.38)',
																		fontSize: 12,
																	}}>
																	{item.Supplier === 'TBO'
																		? item.Segments[0].slice(0, 1).map((i) => {
																				return i.Airline.AirlineName;
																		  })
																		: item.Supplier === 'ETR'
																		? item.Segments[0].Airline_Name
																		: item.Supplier === 'TJK'
																		? item.sI[0].fD.aI.name
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		color: 'rgba(0,0,0,.38)',
																		fontSize: 12,
																	}}>
																	{`${
																		item.Supplier === 'TBO'
																			? item.AirlineCode
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Airline_Code
																			: item.Supplier === 'TJK'
																			? item.sI[0].fD.aI.code
																			: ''
																	}${
																		item.Supplier === 'TBO'
																			? item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Airline.FlightNumber;
																					})
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Flight_Number
																			: item.Supplier === 'TJK'
																			? item.sI[0].fD.fN
																			: ''
																	}`}
																</span>
															</Box>

															<Box>
																<span
																	style={{
																		fontSize: 14,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	{item.Supplier === 'TBO'
																		? item.FareRules[0].Origin
																		: item.Supplier === 'ETR'
																		? item.Origin
																		: item.Supplier === 'TJK'
																		? item.sI[0].da.code
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		fontSize: 20,
																	}}>
																	{item.Supplier === 'TBO'
																		? item.Segments[0].slice(0, 1).map((i) => {
																				return i.Origin.DepTime.substr(11, 5);
																		  })
																		: item.Supplier === 'ETR'
																		? item.Segments[0].Departure_DateTime.split(
																				' '
																		  )[1]
																		: item.Supplier === 'TJK'
																		? item.sI[0].dt.substr(11, 5)
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		fontSize: 12,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	{`${new Date(
																		item.Supplier === 'TBO'
																			? item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Origin.DepTime.split(
																							'T'
																						)[0];
																					})
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Departure_DateTime.split(
																					' '
																			  )[0]
																			: item.Supplier === 'TJK'
																			? item.sI[0].dt.split('T')[0]
																			: ''
																	).toLocaleString('en-us', {
																		weekday: 'short',
																	})} ,  ${new Date(
																		item.Supplier === 'TBO'
																			? item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Origin.DepTime.split(
																							'T'
																						)[0];
																					})
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Departure_DateTime.split(
																					' '
																			  )[0]
																			: item.Supplier === 'TJK'
																			? item.sI[0].dt.split('T')[0]
																			: ''
																	).getDate()} ${new Date(
																		item.Supplier === 'TBO'
																			? item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Origin.DepTime.split(
																							'T'
																						)[0];
																					})
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Departure_DateTime.split(
																					' '
																			  )[0]
																			: item.Supplier === 'TJK'
																			? item.sI[0].dt.split('T')[0]
																			: ''
																	).toLocaleString('en-us', {
																		month: 'short',
																	})}`}
																</span>
																<br></br>
															</Box>
															<Box textAlign={'center'}>
																<span
																	style={{
																		fontSize: 14,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	2hr 15min
																</span>
																<br></br>
																<span>-----------</span>
																<br></br>

																<span
																	style={{
																		fontSize: 12,
																	}}>
																	{item.Supplier === 'TBO'
																		? item.Segments[0].length === 1
																			? 'Non Stop'
																			: item.Segments[0].length === 2
																			? '1 Stop'
																			: item.Segments[0].length === 3
																			? '2 Stop'
																			: ''
																		: item.Supplier === 'ETR'
																		? item.Segments.length === 1
																			? 'Non Stop'
																			: item.Segments.length === 2
																			? '1 Stop'
																			: item.Segments.length === 3
																			? '2 Stop'
																			: ''
																		: item.Supplier === 'TJK'
																		? item.sI.length === 1
																			? 'Non Stop'
																			: item.sI.length === 2
																			? '1 Stop'
																			: item.sI.length === 3
																			? '2 Stop'
																			: ''
																		: ''}
																</span>
															</Box>
															<Box>
																<span
																	style={{
																		fontSize: 14,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	{item.Supplier === 'TBO'
																		? item.Segments[0].length == 2
																			? item.Segments[0]
																					.filter((i, index) => index === 1)
																					.map((it) => {
																						return it.Destination.Airport
																							.AirportCode;
																					})
																			: item.Segments[0].length == 3
																			? item.Segments[0]
																					.filter((i, index) => index === 2)
																					.map((it) => {
																						return it.Destination.Airport
																							.AirportCode;
																					})
																			: item.Segments[0].length == 1
																			? item.Segments[0].map((it) => {
																					return it.Destination.Airport
																						.AirportCode;
																			  })
																			: ''
																		: item.Supplier === 'ETR'
																		? item.Destination
																		: item.Supplier === 'TJK'
																		? item.sI.length === 1
																			? item.sI
																					.filter((i, index) => index === 0)
																					.map((it) => {
																						return it.aa.cityCode;
																					})
																			: item.sI.length === 2
																			? item.sI
																					.filter((i, index) => index === 1)
																					.map((it) => {
																						return it.aa.cityCode;
																					})
																			: item.sI.length === 3
																			? item.sI
																					.filter((i, index) => index === 2)
																					.map((it) => {
																						return it.aa.cityCode;
																					})
																			: ''
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		fontSize: 20,
																	}}>
																	{item.AirlineCode
																		? item.Segments[0].length == 3
																			? item.Segments[0]
																					.filter((i, index) => index === 2)
																					.map((i) => {
																						return i.Destination.ArrTime.substr(
																							11,
																							5
																						);
																					})
																			: item.Segments[0].length == 2
																			? item.Segments[0]
																					.filter((i, index) => index === 1)
																					.map((i) => {
																						return i.Destination.ArrTime.substr(
																							11,
																							5
																						);
																					})
																			: item.Segments[0].length == 1
																			? item.Segments[0]
																					.filter((i, index) => index === 0)
																					.map((i) => {
																						return i.Destination.ArrTime.substr(
																							11,
																							5
																						);
																					})
																			: ''
																		: item.Supplier === 'ETR'
																		? item.Segments.length === 1
																			? item.Segments.filter(
																					(i, index) => index === 0
																			  ).map((it) => {
																					return it.Arrival_DateTime.substr(
																						11,
																						5
																					);
																			  })
																			: item.Segments.length === 2
																			? item.Segments.filter(
																					(i, index) => index === 1
																			  ).map((it) => {
																					return it.Arrival_DateTime.substr(
																						11,
																						5
																					);
																			  })
																			: item.Segments.length === 3
																			? item.Segments.filter(
																					(i, index) => index === 2
																			  ).map((it) => {
																					return it.Arrival_DateTime.substr(
																						11,
																						5
																					);
																			  })
																			: ''
																		: item.Supplier === 'TJK'
																		? item.sI.length === 1
																			? item.sI
																					.filter((i, index) => index === 0)
																					.map((it) => {
																						return it.at.substr(11, 5);
																					})
																			: item.sI.length === 2
																			? item.sI
																					.filter((i, index) => index === 1)
																					.map((it) => {
																						return it.at.substr(11, 5);
																					})
																			: item.sI.length === 3
																			? item.sI
																					.filter((i, index) => index === 2)
																					.map((it) => {
																						return it.at.substr(11, 5);
																					})
																			: ''
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		fontSize: 12,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	{`${new Date(
																		item.AirlineCode
																			? item.Segments[0].length == 3
																				? item.Segments[0]
																						.filter((i, index) => index === 2)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[0].length == 2
																				? item.Segments[0]
																						.filter((i, index) => index === 1)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[0].length == 1
																				? item.Segments[0]
																						.filter((i, index) => index === 0)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: ''
																			: item.Supplier === 'ETR'
																			? item.Segments.length === 1
																				? item.Segments.filter(
																						(i, index) => index === 0
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 2
																				? item.Segments.filter(
																						(i, index) => index === 1
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 3
																				? item.Segments.filter(
																						(i, index) => index === 2
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: ''
																			: item.Supplier === 'TJK'
																			? item.sI.length === 1
																				? item.sI
																						.filter((i, index) => index === 0)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 2
																				? item.sI
																						.filter((i, index) => index === 1)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 3
																				? item.sI
																						.filter((i, index) => index === 2)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: ''
																			: ''
																	).toLocaleString('en-us', {
																		weekday: 'short',
																	})} ,  ${new Date(
																		item.AirlineCode
																			? item.Segments[0].length == 3
																				? item.Segments[0]
																						.filter((i, index) => index === 2)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[0].length == 2
																				? item.Segments[0]
																						.filter((i, index) => index === 1)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[0].length == 1
																				? item.Segments[0]
																						.filter((i, index) => index === 0)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: ''
																			: item.Supplier === 'ETR'
																			? item.Segments.length === 1
																				? item.Segments.filter(
																						(i, index) => index === 0
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 2
																				? item.Segments.filter(
																						(i, index) => index === 1
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 3
																				? item.Segments.filter(
																						(i, index) => index === 2
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: ''
																			: item.Supplier === 'TJK'
																			? item.sI.length === 1
																				? item.sI
																						.filter((i, index) => index === 0)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 2
																				? item.sI
																						.filter((i, index) => index === 1)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 3
																				? item.sI
																						.filter((i, index) => index === 2)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: ''
																			: ''
																	).getDate()} ${new Date(
																		item.AirlineCode
																			? item.Segments[0].length == 3
																				? item.Segments[0]
																						.filter((i, index) => index === 2)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[0].length == 2
																				? item.Segments[0]
																						.filter((i, index) => index === 1)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[0].length == 1
																				? item.Segments[0]
																						.filter((i, index) => index === 0)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: ''
																			: item.Supplier === 'ETR'
																			? item.Segments.length === 1
																				? item.Segments.filter(
																						(i, index) => index === 0
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 2
																				? item.Segments.filter(
																						(i, index) => index === 1
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 3
																				? item.Segments.filter(
																						(i, index) => index === 2
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: ''
																			: item.Supplier === 'TJK'
																			? item.sI.length === 1
																				? item.sI
																						.filter((i, index) => index === 0)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 2
																				? item.sI
																						.filter((i, index) => index === 1)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 3
																				? item.sI
																						.filter((i, index) => index === 2)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: ''
																			: ''
																	).toLocaleString('en-us', {
																		month: 'short',
																	})}`}
																</span>
															</Box>
														</Box>
													</Grid>
													<Grid item xs={6}>
														<Box
															style={{
																display: 'flex',
																justifyContent: 'space-between',
																alignItems: 'center',
																borderRadius: 4,
																padding: 30,
																cursor: 'pointer',
																marginTop: 10,
															}}>
															<Box>
																<img
																	src={`https://nitish.musafirbazar.com/static/media/${
																		item.Supplier === 'TBO'
																			? item.AirlineCode
																			: item.Supplier === 'ETR'
																			? item.Airline_Code
																			: item.Supplier === 'TJK'
																			? item.sI[0].fD.aI.code
																			: ''
																	}.gif`}
																	style={{ height: 25 }}
																/>
																<br></br>
																<span
																	style={{
																		color: 'rgba(0,0,0,.38)',
																		fontSize: 12,
																	}}>
																	{item.Supplier === 'TBO'
																		? item.Segments[1].slice(0, 1).map((i) => {
																				return i.Airline.AirlineName;
																		  })
																		: item.Supplier === 'ETR'
																		? item.Segments[0].Airline_Name
																		: item.Supplier === 'TJK'
																		? item.sI[0].fD.aI.name
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		color: 'rgba(0,0,0,.38)',
																		fontSize: 12,
																	}}>
																	{`${
																		item.Supplier === 'TBO'
																			? item.AirlineCode
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Airline_Code
																			: item.Supplier === 'TJK'
																			? item.sI[0].fD.aI.code
																			: ''
																	}${
																		item.Supplier === 'TBO'
																			? item.Segments[1]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Airline.FlightNumber;
																					})
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Flight_Number
																			: item.Supplier === 'TJK'
																			? item.sI[0].fD.fN
																			: ''
																	}`}
																</span>
															</Box>

															<Box>
																<span
																	style={{
																		fontSize: 14,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	{item.Supplier === 'TBO'
																		? item.FareRules[1].Origin
																		: item.Supplier === 'ETR'
																		? item.Origin
																		: item.Supplier === 'TJK'
																		? item.sI[0].da.code
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		fontSize: 20,
																	}}>
																	{item.Supplier === 'TBO'
																		? item.Segments[1].slice(0, 1).map((i) => {
																				return i.Origin.DepTime.substr(11, 5);
																		  })
																		: item.Supplier === 'ETR'
																		? item.Segments[0].Departure_DateTime.split(
																				' '
																		  )[1]
																		: item.Supplier === 'TJK'
																		? item.sI[0].dt.substr(11, 5)
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		fontSize: 12,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	{`${new Date(
																		item.Supplier === 'TBO'
																			? item.Segments[1]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Origin.DepTime.split(
																							'T'
																						)[0];
																					})
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Departure_DateTime.split(
																					' '
																			  )[0]
																			: item.Supplier === 'TJK'
																			? item.sI[0].dt.split('T')[0]
																			: ''
																	).toLocaleString('en-us', {
																		weekday: 'short',
																	})} ,  ${new Date(
																		item.Supplier === 'TBO'
																			? item.Segments[1]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Origin.DepTime.split(
																							'T'
																						)[0];
																					})
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Departure_DateTime.split(
																					' '
																			  )[0]
																			: item.Supplier === 'TJK'
																			? item.sI[0].dt.split('T')[0]
																			: ''
																	).getDate()} ${new Date(
																		item.Supplier === 'TBO'
																			? item.Segments[1]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Origin.DepTime.split(
																							'T'
																						)[0];
																					})
																			: item.Supplier === 'ETR'
																			? item.Segments[0].Departure_DateTime.split(
																					' '
																			  )[0]
																			: item.Supplier === 'TJK'
																			? item.sI[0].dt.split('T')[0]
																			: ''
																	).toLocaleString('en-us', {
																		month: 'short',
																	})}`}
																</span>
																<br></br>
															</Box>
															<Box textAlign={'center'}>
																<span
																	style={{
																		fontSize: 14,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	2hr 15min
																</span>
																<br></br>
																<span>-----------</span>
																<br></br>

																<span
																	style={{
																		fontSize: 12,
																	}}>
																	{item.Supplier === 'TBO'
																		? item.Segments[1].length === 1
																			? 'Non Stop'
																			: item.Segments[1].length === 2
																			? '1 Stop'
																			: item.Segments[1].length === 3
																			? '2 Stop'
																			: ''
																		: item.Supplier === 'ETR'
																		? item.Segments.length === 1
																			? 'Non Stop'
																			: item.Segments.length === 2
																			? '1 Stop'
																			: item.Segments.length === 3
																			? '2 Stop'
																			: ''
																		: item.Supplier === 'TJK'
																		? item.sI.length === 1
																			? 'Non Stop'
																			: item.sI.length === 2
																			? '1 Stop'
																			: item.sI.length === 3
																			? '2 Stop'
																			: ''
																		: ''}
																</span>
															</Box>
															<Box>
																<span
																	style={{
																		fontSize: 14,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	{item.Supplier === 'TBO'
																		? item.Segments[1].length == 2
																			? item.Segments[1]
																					.filter((i, index) => index === 1)
																					.map((it) => {
																						return it.Destination.Airport
																							.AirportCode;
																					})
																			: item.Segments[1].length == 3
																			? item.Segments[1]
																					.filter((i, index) => index === 2)
																					.map((it) => {
																						return it.Destination.Airport
																							.AirportCode;
																					})
																			: item.Segments[1].length == 1
																			? item.Segments[1].map((it) => {
																					return it.Destination.Airport
																						.AirportCode;
																			  })
																			: ''
																		: item.Supplier === 'ETR'
																		? item.Destination
																		: item.Supplier === 'TJK'
																		? item.sI.length === 1
																			? item.sI
																					.filter((i, index) => index === 0)
																					.map((it) => {
																						return it.aa.cityCode;
																					})
																			: item.sI.length === 2
																			? item.sI
																					.filter((i, index) => index === 1)
																					.map((it) => {
																						return it.aa.cityCode;
																					})
																			: item.sI.length === 3
																			? item.sI
																					.filter((i, index) => index === 2)
																					.map((it) => {
																						return it.aa.cityCode;
																					})
																			: ''
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		fontSize: 20,
																	}}>
																	{item.AirlineCode
																		? item.Segments[1].length == 3
																			? item.Segments[1]
																					.filter((i, index) => index === 2)
																					.map((i) => {
																						return i.Destination.ArrTime.substr(
																							11,
																							5
																						);
																					})
																			: item.Segments[1].length == 2
																			? item.Segments[1]
																					.filter((i, index) => index === 1)
																					.map((i) => {
																						return i.Destination.ArrTime.substr(
																							11,
																							5
																						);
																					})
																			: item.Segments[1].length == 1
																			? item.Segments[1]
																					.filter((i, index) => index === 0)
																					.map((i) => {
																						return i.Destination.ArrTime.substr(
																							11,
																							5
																						);
																					})
																			: ''
																		: item.Supplier === 'ETR'
																		? item.Segments.length === 1
																			? item.Segments.filter(
																					(i, index) => index === 0
																			  ).map((it) => {
																					return it.Arrival_DateTime.substr(
																						11,
																						5
																					);
																			  })
																			: item.Segments.length === 2
																			? item.Segments.filter(
																					(i, index) => index === 1
																			  ).map((it) => {
																					return it.Arrival_DateTime.substr(
																						11,
																						5
																					);
																			  })
																			: item.Segments.length === 3
																			? item.Segments.filter(
																					(i, index) => index === 2
																			  ).map((it) => {
																					return it.Arrival_DateTime.substr(
																						11,
																						5
																					);
																			  })
																			: ''
																		: item.Supplier === 'TJK'
																		? item.sI.length === 1
																			? item.sI
																					.filter((i, index) => index === 0)
																					.map((it) => {
																						return it.at.substr(11, 5);
																					})
																			: item.sI.length === 2
																			? item.sI
																					.filter((i, index) => index === 1)
																					.map((it) => {
																						return it.at.substr(11, 5);
																					})
																			: item.sI.length === 3
																			? item.sI
																					.filter((i, index) => index === 2)
																					.map((it) => {
																						return it.at.substr(11, 5);
																					})
																			: ''
																		: ''}
																</span>
																<br></br>
																<span
																	style={{
																		fontSize: 12,
																		color: 'rgba(0,0,0,.38)',
																	}}>
																	{`${new Date(
																		item.AirlineCode
																			? item.Segments[1].length == 3
																				? item.Segments[1]
																						.filter((i, index) => index === 2)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[1].length == 2
																				? item.Segments[1]
																						.filter((i, index) => index === 1)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[1].length == 1
																				? item.Segments[1]
																						.filter((i, index) => index === 0)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: ''
																			: item.Supplier === 'ETR'
																			? item.Segments.length === 1
																				? item.Segments.filter(
																						(i, index) => index === 0
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 2
																				? item.Segments.filter(
																						(i, index) => index === 1
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 3
																				? item.Segments.filter(
																						(i, index) => index === 2
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: ''
																			: item.Supplier === 'TJK'
																			? item.sI.length === 1
																				? item.sI
																						.filter((i, index) => index === 0)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 2
																				? item.sI
																						.filter((i, index) => index === 1)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 3
																				? item.sI
																						.filter((i, index) => index === 2)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: ''
																			: ''
																	).toLocaleString('en-us', {
																		weekday: 'short',
																	})} ,  ${new Date(
																		item.AirlineCode
																			? item.Segments[1].length == 3
																				? item.Segments[1]
																						.filter((i, index) => index === 2)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[1].length == 2
																				? item.Segments[1]
																						.filter((i, index) => index === 1)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[1].length == 1
																				? item.Segments[1]
																						.filter((i, index) => index === 0)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: ''
																			: item.Supplier === 'ETR'
																			? item.Segments.length === 1
																				? item.Segments.filter(
																						(i, index) => index === 0
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 2
																				? item.Segments.filter(
																						(i, index) => index === 1
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 3
																				? item.Segments.filter(
																						(i, index) => index === 2
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: ''
																			: item.Supplier === 'TJK'
																			? item.sI.length === 1
																				? item.sI
																						.filter((i, index) => index === 0)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 2
																				? item.sI
																						.filter((i, index) => index === 1)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 3
																				? item.sI
																						.filter((i, index) => index === 2)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: ''
																			: ''
																	).getDate()} ${new Date(
																		item.AirlineCode
																			? item.Segments[1].length == 3
																				? item.Segments[1]
																						.filter((i, index) => index === 2)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[1].length == 2
																				? item.Segments[1]
																						.filter((i, index) => index === 1)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: item.Segments[1].length == 1
																				? item.Segments[1]
																						.filter((i, index) => index === 0)
																						.map((i) => {
																							return i.Destination.ArrTime.split(
																								'T'
																							)[0];
																						})
																				: ''
																			: item.Supplier === 'ETR'
																			? item.Segments.length === 1
																				? item.Segments.filter(
																						(i, index) => index === 0
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 2
																				? item.Segments.filter(
																						(i, index) => index === 1
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: item.Segments.length === 3
																				? item.Segments.filter(
																						(i, index) => index === 2
																				  ).map((it) => {
																						return it.Arrival_DateTime.split(
																							' '
																						)[0];
																				  })
																				: ''
																			: item.Supplier === 'TJK'
																			? item.sI.length === 1
																				? item.sI
																						.filter((i, index) => index === 0)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 2
																				? item.sI
																						.filter((i, index) => index === 1)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: item.sI.length === 3
																				? item.sI
																						.filter((i, index) => index === 2)
																						.map((it) => {
																							return it.at.split('T')[0];
																						})
																				: ''
																			: ''
																	).toLocaleString('en-us', {
																		month: 'short',
																	})}`}
																</span>
															</Box>
															<h4>
																₹
																{item.Supplier === 'TBO'
																	? Number(
																			Math.round(
																				Number(
																					Number(
																						Math.round(item.Fare.Total_Amount)
																					) -
																						Number(
																							Math.round(item.Fare.MFB_Discount)
																						)
																				)
																			)
																	  )
																	: item.Supplier === 'ETR'
																	? Number(
																			Math.round(
																				Number(
																					Number(
																						Math.round(item.Fares.Total_Amount)
																					)
																				)
																			)
																	  )
																	: item.Supplier === 'TJK'
																	? Number(
																			Math.round(
																				Number(
																					Number(
																						Math.round(
																							item.totalPriceList.fd
																								.Total_Amount
																						)
																					)
																				)
																			)
																	  )
																	: ''}
															</h4>
														</Box>
													</Grid>
												</Grid>
											</>
										) : (
											''
										);
									})}
								</InfiniteScroll>
							) : (
								Array.from(Array(10)).map((i) => {
									return <FlightRoundTripSkeleton />;
								})
							)
						) : filterData?.length > 0 ? (
							<InfiniteScroll
								dataLength={scrollVal}
								next={fetchMoreData}
								hasMore={hasMorefilterData}
								loader={<h4 style={{ textAlign: 'center' }}>Loading...</h4>}
								endMessage={
									<p style={{ textAlign: 'center' }}>
										<b>No More Flights</b>
									</p>
								}>
								{filterData.map((item, index) => {
									return index < scrollVal ? (
										<>
											<Grid
												onClick={() => dispatch(setSelectedOnwardFlight(item))}
												container
												spacing={2}
												style={{
													background:
														item?.Supplier === 'TBO'
															? item?.ResultIndex === onwardFlight?.ResultIndex
																? '#f0f0f0'
																: '#fff'
															: '',
													filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, .25))',
													marginTop: 10,
												}}>
												<Grid item xs={6}>
													<Box
														style={{
															display: 'flex',
															justifyContent: 'space-between',
															alignItems: 'center',
															borderRadius: 4,
															padding: 30,
															marginTop: 10,
															cursor: 'pointer',
														}}>
														<Box>
															<img
																src={`https://nitish.musafirbazar.com/static/media/${
																	item.Supplier === 'TBO'
																		? item.AirlineCode
																		: item.Supplier === 'ETR'
																		? item.Airline_Code
																		: item.Supplier === 'TJK'
																		? item.sI[0].fD.aI.code
																		: ''
																}.gif`}
																style={{ height: 25 }}
															/>
															<br></br>
															<span
																style={{
																	color: 'rgba(0,0,0,.38)',
																	fontSize: 12,
																}}>
																{item.Supplier === 'TBO'
																	? item.Segments[0].slice(0, 1).map((i) => {
																			return i.Airline.AirlineName;
																	  })
																	: item.Supplier === 'ETR'
																	? item.Segments[0].Airline_Name
																	: item.Supplier === 'TJK'
																	? item.sI[0].fD.aI.name
																	: ''}
															</span>
															<br></br>
															<span
																style={{
																	color: 'rgba(0,0,0,.38)',
																	fontSize: 12,
																}}>
																{`${
																	item.Supplier === 'TBO'
																		? item.AirlineCode
																		: item.Supplier === 'ETR'
																		? item.Segments[0].Airline_Code
																		: item.Supplier === 'TJK'
																		? item.sI[0].fD.aI.code
																		: ''
																}${
																	item.Supplier === 'TBO'
																		? item.Segments[0].slice(0, 1).map((i) => {
																				return i.Airline.FlightNumber;
																		  })
																		: item.Supplier === 'ETR'
																		? item.Segments[0].Flight_Number
																		: item.Supplier === 'TJK'
																		? item.sI[0].fD.fN
																		: ''
																}`}
															</span>
														</Box>

														<Box>
															<span
																style={{
																	fontSize: 14,
																	color: 'rgba(0,0,0,.38)',
																}}>
																{item.Supplier === 'TBO'
																	? item.FareRules[0].Origin
																	: item.Supplier === 'ETR'
																	? item.Origin
																	: item.Supplier === 'TJK'
																	? item.sI[0].da.code
																	: ''}
															</span>
															<br></br>
															<span
																style={{
																	fontSize: 20,
																}}>
																{item.Supplier === 'TBO'
																	? item.Segments[0].slice(0, 1).map((i) => {
																			return i.Origin.DepTime.substr(11, 5);
																	  })
																	: item.Supplier === 'ETR'
																	? item.Segments[0].Departure_DateTime.split(
																			' '
																	  )[1]
																	: item.Supplier === 'TJK'
																	? item.sI[0].dt.substr(11, 5)
																	: ''}
															</span>
															<br></br>
															<span
																style={{
																	fontSize: 12,
																	color: 'rgba(0,0,0,.38)',
																}}>
																{`${new Date(
																	item.Supplier === 'TBO'
																		? item.Segments[0].slice(0, 1).map((i) => {
																				return i.Origin.DepTime.split('T')[0];
																		  })
																		: item.Supplier === 'ETR'
																		? item.Segments[0].Departure_DateTime.split(
																				' '
																		  )[0]
																		: item.Supplier === 'TJK'
																		? item.sI[0].dt.split('T')[0]
																		: ''
																).toLocaleString('en-us', {
																	weekday: 'short',
																})} ,  ${new Date(
																	item.Supplier === 'TBO'
																		? item.Segments[0].slice(0, 1).map((i) => {
																				return i.Origin.DepTime.split('T')[0];
																		  })
																		: item.Supplier === 'ETR'
																		? item.Segments[0].Departure_DateTime.split(
																				' '
																		  )[0]
																		: item.Supplier === 'TJK'
																		? item.sI[0].dt.split('T')[0]
																		: ''
																).getDate()} ${new Date(
																	item.Supplier === 'TBO'
																		? item.Segments[0].slice(0, 1).map((i) => {
																				return i.Origin.DepTime.split('T')[0];
																		  })
																		: item.Supplier === 'ETR'
																		? item.Segments[0].Departure_DateTime.split(
																				' '
																		  )[0]
																		: item.Supplier === 'TJK'
																		? item.sI[0].dt.split('T')[0]
																		: ''
																).toLocaleString('en-us', {
																	month: 'short',
																})}`}
															</span>
															<br></br>
														</Box>
														<Box textAlign={'center'}>
															<span
																style={{
																	fontSize: 14,
																	color: 'rgba(0,0,0,.38)',
																}}>
																2hr 15min
															</span>
															<br></br>
															<span>-----------</span>
															<br></br>

															<span
																style={{
																	fontSize: 12,
																}}>
																{item.Supplier === 'TBO'
																	? item.Segments[0].length === 1
																		? 'Non Stop'
																		: item.Segments[0].length === 2
																		? '1 Stop'
																		: item.Segments[0].length === 3
																		? '2 Stop'
																		: ''
																	: item.Supplier === 'ETR'
																	? item.Segments.length === 1
																		? 'Non Stop'
																		: item.Segments.length === 2
																		? '1 Stop'
																		: item.Segments.length === 3
																		? '2 Stop'
																		: ''
																	: item.Supplier === 'TJK'
																	? item.sI.length === 1
																		? 'Non Stop'
																		: item.sI.length === 2
																		? '1 Stop'
																		: item.sI.length === 3
																		? '2 Stop'
																		: ''
																	: ''}
															</span>
														</Box>
														<Box>
															<span
																style={{
																	fontSize: 14,
																	color: 'rgba(0,0,0,.38)',
																}}>
																{item.Supplier === 'TBO'
																	? item.Segments[0].length == 2
																		? item.Segments[0]
																				.filter((i, index) => index === 1)
																				.map((it) => {
																					return it.Destination.Airport
																						.AirportCode;
																				})
																		: item.Segments[0].length == 3
																		? item.Segments[0]
																				.filter((i, index) => index === 2)
																				.map((it) => {
																					return it.Destination.Airport
																						.AirportCode;
																				})
																		: item.Segments[0].length == 1
																		? item.Segments[0].map((it) => {
																				return it.Destination.Airport
																					.AirportCode;
																		  })
																		: ''
																	: item.Supplier === 'ETR'
																	? item.Destination
																	: item.Supplier === 'TJK'
																	? item.sI.length === 1
																		? item.sI
																				.filter((i, index) => index === 0)
																				.map((it) => {
																					return it.aa.cityCode;
																				})
																		: item.sI.length === 2
																		? item.sI
																				.filter((i, index) => index === 1)
																				.map((it) => {
																					return it.aa.cityCode;
																				})
																		: item.sI.length === 3
																		? item.sI
																				.filter((i, index) => index === 2)
																				.map((it) => {
																					return it.aa.cityCode;
																				})
																		: ''
																	: ''}
															</span>
															<br></br>
															<span
																style={{
																	fontSize: 20,
																}}>
																{item.AirlineCode
																	? item.Segments[0].length == 3
																		? item.Segments[0]
																				.filter((i, index) => index === 2)
																				.map((i) => {
																					return i.Destination.ArrTime.substr(
																						11,
																						5
																					);
																				})
																		: item.Segments[0].length == 2
																		? item.Segments[0]
																				.filter((i, index) => index === 1)
																				.map((i) => {
																					return i.Destination.ArrTime.substr(
																						11,
																						5
																					);
																				})
																		: item.Segments[0].length == 1
																		? item.Segments[0]
																				.filter((i, index) => index === 0)
																				.map((i) => {
																					return i.Destination.ArrTime.substr(
																						11,
																						5
																					);
																				})
																		: ''
																	: item.Supplier === 'ETR'
																	? item.Segments.length === 1
																		? item.Segments.filter(
																				(i, index) => index === 0
																		  ).map((it) => {
																				return it.Arrival_DateTime.substr(
																					11,
																					5
																				);
																		  })
																		: item.Segments.length === 2
																		? item.Segments.filter(
																				(i, index) => index === 1
																		  ).map((it) => {
																				return it.Arrival_DateTime.substr(
																					11,
																					5
																				);
																		  })
																		: item.Segments.length === 3
																		? item.Segments.filter(
																				(i, index) => index === 2
																		  ).map((it) => {
																				return it.Arrival_DateTime.substr(
																					11,
																					5
																				);
																		  })
																		: ''
																	: item.Supplier === 'TJK'
																	? item.sI.length === 1
																		? item.sI
																				.filter((i, index) => index === 0)
																				.map((it) => {
																					return it.at.substr(11, 5);
																				})
																		: item.sI.length === 2
																		? item.sI
																				.filter((i, index) => index === 1)
																				.map((it) => {
																					return it.at.substr(11, 5);
																				})
																		: item.sI.length === 3
																		? item.sI
																				.filter((i, index) => index === 2)
																				.map((it) => {
																					return it.at.substr(11, 5);
																				})
																		: ''
																	: ''}
															</span>
															<br></br>
															<span
																style={{
																	fontSize: 12,
																	color: 'rgba(0,0,0,.38)',
																}}>
																{`${new Date(
																	item.AirlineCode
																		? item.Segments[0].length == 3
																			? item.Segments[0]
																					.filter((i, index) => index === 2)
																					.map((i) => {
																						return i.Destination.ArrTime.split(
																							'T'
																						)[0];
																					})
																			: item.Segments[0].length == 2
																			? item.Segments[0]
																					.filter((i, index) => index === 1)
																					.map((i) => {
																						return i.Destination.ArrTime.split(
																							'T'
																						)[0];
																					})
																			: item.Segments[0].length == 1
																			? item.Segments[0]
																					.filter((i, index) => index === 0)
																					.map((i) => {
																						return i.Destination.ArrTime.split(
																							'T'
																						)[0];
																					})
																			: ''
																		: item.Supplier === 'ETR'
																		? item.Segments.length === 1
																			? item.Segments.filter(
																					(i, index) => index === 0
																			  ).map((it) => {
																					return it.Arrival_DateTime.split(
																						' '
																					)[0];
																			  })
																			: item.Segments.length === 2
																			? item.Segments.filter(
																					(i, index) => index === 1
																			  ).map((it) => {
																					return it.Arrival_DateTime.split(
																						' '
																					)[0];
																			  })
																			: item.Segments.length === 3
																			? item.Segments.filter(
																					(i, index) => index === 2
																			  ).map((it) => {
																					return it.Arrival_DateTime.split(
																						' '
																					)[0];
																			  })
																			: ''
																		: item.Supplier === 'TJK'
																		? item.sI.length === 1
																			? item.sI
																					.filter((i, index) => index === 0)
																					.map((it) => {
																						return it.at.split('T')[0];
																					})
																			: item.sI.length === 2
																			? item.sI
																					.filter((i, index) => index === 1)
																					.map((it) => {
																						return it.at.split('T')[0];
																					})
																			: item.sI.length === 3
																			? item.sI
																					.filter((i, index) => index === 2)
																					.map((it) => {
																						return it.at.split('T')[0];
																					})
																			: ''
																		: ''
																).toLocaleString('en-us', {
																	weekday: 'short',
																})} ,  ${new Date(
																	item.AirlineCode
																		? item.Segments[0].length == 3
																			? item.Segments[0]
																					.filter((i, index) => index === 2)
																					.map((i) => {
																						return i.Destination.ArrTime.split(
																							'T'
																						)[0];
																					})
																			: item.Segments[0].length == 2
																			? item.Segments[0]
																					.filter((i, index) => index === 1)
																					.map((i) => {
																						return i.Destination.ArrTime.split(
																							'T'
																						)[0];
																					})
																			: item.Segments[0].length == 1
																			? item.Segments[0]
																					.filter((i, index) => index === 0)
																					.map((i) => {
																						return i.Destination.ArrTime.split(
																							'T'
																						)[0];
																					})
																			: ''
																		: item.Supplier === 'ETR'
																		? item.Segments.length === 1
																			? item.Segments.filter(
																					(i, index) => index === 0
																			  ).map((it) => {
																					return it.Arrival_DateTime.split(
																						' '
																					)[0];
																			  })
																			: item.Segments.length === 2
																			? item.Segments.filter(
																					(i, index) => index === 1
																			  ).map((it) => {
																					return it.Arrival_DateTime.split(
																						' '
																					)[0];
																			  })
																			: item.Segments.length === 3
																			? item.Segments.filter(
																					(i, index) => index === 2
																			  ).map((it) => {
																					return it.Arrival_DateTime.split(
																						' '
																					)[0];
																			  })
																			: ''
																		: item.Supplier === 'TJK'
																		? item.sI.length === 1
																			? item.sI
																					.filter((i, index) => index === 0)
																					.map((it) => {
																						return it.at.split('T')[0];
																					})
																			: item.sI.length === 2
																			? item.sI
																					.filter((i, index) => index === 1)
																					.map((it) => {
																						return it.at.split('T')[0];
																					})
																			: item.sI.length === 3
																			? item.sI
																					.filter((i, index) => index === 2)
																					.map((it) => {
																						return it.at.split('T')[0];
																					})
																			: ''
																		: ''
																).getDate()} ${new Date(
																	item.AirlineCode
																		? item.Segments[0].length == 3
																			? item.Segments[0]
																					.filter((i, index) => index === 2)
																					.map((i) => {
																						return i.Destination.ArrTime.split(
																							'T'
																						)[0];
																					})
																			: item.Segments[0].length == 2
																			? item.Segments[0]
																					.filter((i, index) => index === 1)
																					.map((i) => {
																						return i.Destination.ArrTime.split(
																							'T'
																						)[0];
																					})
																			: item.Segments[0].length == 1
																			? item.Segments[0]
																					.filter((i, index) => index === 0)
																					.map((i) => {
																						return i.Destination.ArrTime.split(
																							'T'
																						)[0];
																					})
																			: ''
																		: item.Supplier === 'ETR'
																		? item.Segments.length === 1
																			? item.Segments.filter(
																					(i, index) => index === 0
																			  ).map((it) => {
																					return it.Arrival_DateTime.split(
																						' '
																					)[0];
																			  })
																			: item.Segments.length === 2
																			? item.Segments.filter(
																					(i, index) => index === 1
																			  ).map((it) => {
																					return it.Arrival_DateTime.split(
																						' '
																					)[0];
																			  })
																			: item.Segments.length === 3
																			? item.Segments.filter(
																					(i, index) => index === 2
																			  ).map((it) => {
																					return it.Arrival_DateTime.split(
																						' '
																					)[0];
																			  })
																			: ''
																		: item.Supplier === 'TJK'
																		? item.sI.length === 1
																			? item.sI
																					.filter((i, index) => index === 0)
																					.map((it) => {
																						return it.at.split('T')[0];
																					})
																			: item.sI.length === 2
																			? item.sI
																					.filter((i, index) => index === 1)
																					.map((it) => {
																						return it.at.split('T')[0];
																					})
																			: item.sI.length === 3
																			? item.sI
																					.filter((i, index) => index === 2)
																					.map((it) => {
																						return it.at.split('T')[0];
																					})
																			: ''
																		: ''
																).toLocaleString('en-us', {
																	month: 'short',
																})}`}
															</span>
														</Box>
													</Box>
												</Grid>
												<Grid item xs={6}>
													<Box
														style={{
															display: 'flex',
															justifyContent: 'space-between',
															alignItems: 'center',
															borderRadius: 4,
															padding: 30,
															cursor: 'pointer',
															marginTop: 10,
														}}>
														<Box>
															<img
																src={`https://nitish.musafirbazar.com/static/media/${
																	item.Supplier === 'TBO'
																		? item.AirlineCode
																		: item.Supplier === 'ETR'
																		? item.Airline_Code
																		: item.Supplier === 'TJK'
																		? item.sI[0].fD.aI.code
																		: ''
																}.gif`}
																style={{ height: 25 }}
															/>
															<br></br>
															<span
																style={{
																	color: 'rgba(0,0,0,.38)',
																	fontSize: 12,
																}}>
																{item.Supplier === 'TBO'
																	? item.Segments[1].slice(0, 1).map((i) => {
																			return i.Airline.AirlineName;
																	  })
																	: item.Supplier === 'ETR'
																	? item.Segments[0].Airline_Name
																	: item.Supplier === 'TJK'
																	? item.sI[0].fD.aI.name
																	: ''}
															</span>
															<br></br>
															<span
																style={{
																	color: 'rgba(0,0,0,.38)',
																	fontSize: 12,
																}}>
																{`${
																	item.Supplier === 'TBO'
																		? item.AirlineCode
																		: item.Supplier === 'ETR'
																		? item.Segments[0].Airline_Code
																		: item.Supplier === 'TJK'
																		? item.sI[0].fD.aI.code
																		: ''
																}${
																	item.Supplier === 'TBO'
																		? item.Segments[1].slice(0, 1).map((i) => {
																				return i.Airline.FlightNumber;
																		  })
																		: item.Supplier === 'ETR'
																		? item.Segments[0].Flight_Number
																		: item.Supplier === 'TJK'
																		? item.sI[0].fD.fN
																		: ''
																}`}
															</span>
														</Box>

														<Box>
															<span
																style={{
																	fontSize: 14,
																	color: 'rgba(0,0,0,.38)',
																}}>
																{item.Supplier === 'TBO'
																	? item.FareRules[1].Origin
																	: item.Supplier === 'ETR'
																	? item.Origin
																	: item.Supplier === 'TJK'
																	? item.sI[0].da.code
																	: ''}
															</span>
															<br></br>
															<span
																style={{
																	fontSize: 20,
																}}>
																{item.Supplier === 'TBO'
																	? item.Segments[1].slice(0, 1).map((i) => {
																			return i.Origin.DepTime.substr(11, 5);
																	  })
																	: item.Supplier === 'ETR'
																	? item.Segments[0].Departure_DateTime.split(
																			' '
																	  )[1]
																	: item.Supplier === 'TJK'
																	? item.sI[0].dt.substr(11, 5)
																	: ''}
															</span>
															<br></br>
															<span
																style={{
																	fontSize: 12,
																	color: 'rgba(0,0,0,.38)',
																}}>
																{`${new Date(
																	item.Supplier === 'TBO'
																		? item.Segments[1].slice(0, 1).map((i) => {
																				return i.Origin.DepTime.split('T')[0];
																		  })
																		: item.Supplier === 'ETR'
																		? item.Segments[0].Departure_DateTime.split(
																				' '
																		  )[0]
																		: item.Supplier === 'TJK'
																		? item.sI[0].dt.split('T')[0]
																		: ''
																).toLocaleString('en-us', {
																	weekday: 'short',
																})} ,  ${new Date(
																	item.Supplier === 'TBO'
																		? item.Segments[1].slice(0, 1).map((i) => {
																				return i.Origin.DepTime.split('T')[0];
																		  })
																		: item.Supplier === 'ETR'
																		? item.Segments[0].Departure_DateTime.split(
																				' '
																		  )[0]
																		: item.Supplier === 'TJK'
																		? item.sI[0].dt.split('T')[0]
																		: ''
																).getDate()} ${new Date(
																	item.Supplier === 'TBO'
																		? item.Segments[1].slice(0, 1).map((i) => {
																				return i.Origin.DepTime.split('T')[0];
																		  })
																		: item.Supplier === 'ETR'
																		? item.Segments[0].Departure_DateTime.split(
																				' '
																		  )[0]
																		: item.Supplier === 'TJK'
																		? item.sI[0].dt.split('T')[0]
																		: ''
																).toLocaleString('en-us', {
																	month: 'short',
																})}`}
															</span>
															<br></br>
														</Box>
														<Box textAlign={'center'}>
															<span
																style={{
																	fontSize: 14,
																	color: 'rgba(0,0,0,.38)',
																}}>
																2hr 15min
															</span>
															<br></br>
															<span>-----------</span>
															<br></br>

															<span
																style={{
																	fontSize: 12,
																}}>
																{item.Supplier === 'TBO'
																	? item.Segments[1].length === 1
																		? 'Non Stop'
																		: item.Segments[1].length === 2
																		? '1 Stop'
																		: item.Segments[1].length === 3
																		? '2 Stop'
																		: ''
																	: item.Supplier === 'ETR'
																	? item.Segments.length === 1
																		? 'Non Stop'
																		: item.Segments.length === 2
																		? '1 Stop'
																		: item.Segments.length === 3
																		? '2 Stop'
																		: ''
																	: item.Supplier === 'TJK'
																	? item.sI.length === 1
																		? 'Non Stop'
																		: item.sI.length === 2
																		? '1 Stop'
																		: item.sI.length === 3
																		? '2 Stop'
																		: ''
																	: ''}
															</span>
														</Box>
														<Box>
															<span
																style={{
																	fontSize: 14,
																	color: 'rgba(0,0,0,.38)',
																}}>
																{item.Supplier === 'TBO'
																	? item.Segments[1].length == 2
																		? item.Segments[1]
																				.filter((i, index) => index === 1)
																				.map((it) => {
																					return it.Destination.Airport
																						.AirportCode;
																				})
																		: item.Segments[1].length == 3
																		? item.Segments[1]
																				.filter((i, index) => index === 2)
																				.map((it) => {
																					return it.Destination.Airport
																						.AirportCode;
																				})
																		: item.Segments[1].length == 1
																		? item.Segments[1].map((it) => {
																				return it.Destination.Airport
																					.AirportCode;
																		  })
																		: ''
																	: item.Supplier === 'ETR'
																	? item.Destination
																	: item.Supplier === 'TJK'
																	? item.sI.length === 1
																		? item.sI
																				.filter((i, index) => index === 0)
																				.map((it) => {
																					return it.aa.cityCode;
																				})
																		: item.sI.length === 2
																		? item.sI
																				.filter((i, index) => index === 1)
																				.map((it) => {
																					return it.aa.cityCode;
																				})
																		: item.sI.length === 3
																		? item.sI
																				.filter((i, index) => index === 2)
																				.map((it) => {
																					return it.aa.cityCode;
																				})
																		: ''
																	: ''}
															</span>
															<br></br>
															<span
																style={{
																	fontSize: 20,
																}}>
																{item.AirlineCode
																	? item.Segments[1].length == 3
																		? item.Segments[1]
																				.filter((i, index) => index === 2)
																				.map((i) => {
																					return i.Destination.ArrTime.substr(
																						11,
																						5
																					);
																				})
																		: item.Segments[1].length == 2
																		? item.Segments[1]
																				.filter((i, index) => index === 1)
																				.map((i) => {
																					return i.Destination.ArrTime.substr(
																						11,
																						5
																					);
																				})
																		: item.Segments[1].length == 1
																		? item.Segments[1]
																				.filter((i, index) => index === 0)
																				.map((i) => {
																					return i.Destination.ArrTime.substr(
																						11,
																						5
																					);
																				})
																		: ''
																	: item.Supplier === 'ETR'
																	? item.Segments.length === 1
																		? item.Segments.filter(
																				(i, index) => index === 0
																		  ).map((it) => {
																				return it.Arrival_DateTime.substr(
																					11,
																					5
																				);
																		  })
																		: item.Segments.length === 2
																		? item.Segments.filter(
																				(i, index) => index === 1
																		  ).map((it) => {
																				return it.Arrival_DateTime.substr(
																					11,
																					5
																				);
																		  })
																		: item.Segments.length === 3
																		? item.Segments.filter(
																				(i, index) => index === 2
																		  ).map((it) => {
																				return it.Arrival_DateTime.substr(
																					11,
																					5
																				);
																		  })
																		: ''
																	: item.Supplier === 'TJK'
																	? item.sI.length === 1
																		? item.sI
																				.filter((i, index) => index === 0)
																				.map((it) => {
																					return it.at.substr(11, 5);
																				})
																		: item.sI.length === 2
																		? item.sI
																				.filter((i, index) => index === 1)
																				.map((it) => {
																					return it.at.substr(11, 5);
																				})
																		: item.sI.length === 3
																		? item.sI
																				.filter((i, index) => index === 2)
																				.map((it) => {
																					return it.at.substr(11, 5);
																				})
																		: ''
																	: ''}
															</span>
															<br></br>
															<span
																style={{
																	fontSize: 12,
																	color: 'rgba(0,0,0,.38)',
																}}>
																{`${new Date(
																	item.AirlineCode
																		? item.Segments[1].length == 3
																			? item.Segments[1]
																					.filter((i, index) => index === 2)
																					.map((i) => {
																						return i.Destination.ArrTime.split(
																							'T'
																						)[0];
																					})
																			: item.Segments[1].length == 2
																			? item.Segments[1]
																					.filter((i, index) => index === 1)
																					.map((i) => {
																						return i.Destination.ArrTime.split(
																							'T'
																						)[0];
																					})
																			: item.Segments[1].length == 1
																			? item.Segments[1]
																					.filter((i, index) => index === 0)
																					.map((i) => {
																						return i.Destination.ArrTime.split(
																							'T'
																						)[0];
																					})
																			: ''
																		: item.Supplier === 'ETR'
																		? item.Segments.length === 1
																			? item.Segments.filter(
																					(i, index) => index === 0
																			  ).map((it) => {
																					return it.Arrival_DateTime.split(
																						' '
																					)[0];
																			  })
																			: item.Segments.length === 2
																			? item.Segments.filter(
																					(i, index) => index === 1
																			  ).map((it) => {
																					return it.Arrival_DateTime.split(
																						' '
																					)[0];
																			  })
																			: item.Segments.length === 3
																			? item.Segments.filter(
																					(i, index) => index === 2
																			  ).map((it) => {
																					return it.Arrival_DateTime.split(
																						' '
																					)[0];
																			  })
																			: ''
																		: item.Supplier === 'TJK'
																		? item.sI.length === 1
																			? item.sI
																					.filter((i, index) => index === 0)
																					.map((it) => {
																						return it.at.split('T')[0];
																					})
																			: item.sI.length === 2
																			? item.sI
																					.filter((i, index) => index === 1)
																					.map((it) => {
																						return it.at.split('T')[0];
																					})
																			: item.sI.length === 3
																			? item.sI
																					.filter((i, index) => index === 2)
																					.map((it) => {
																						return it.at.split('T')[0];
																					})
																			: ''
																		: ''
																).toLocaleString('en-us', {
																	weekday: 'short',
																})} ,  ${new Date(
																	item.AirlineCode
																		? item.Segments[1].length == 3
																			? item.Segments[1]
																					.filter((i, index) => index === 2)
																					.map((i) => {
																						return i.Destination.ArrTime.split(
																							'T'
																						)[0];
																					})
																			: item.Segments[1].length == 2
																			? item.Segments[1]
																					.filter((i, index) => index === 1)
																					.map((i) => {
																						return i.Destination.ArrTime.split(
																							'T'
																						)[0];
																					})
																			: item.Segments[1].length == 1
																			? item.Segments[1]
																					.filter((i, index) => index === 0)
																					.map((i) => {
																						return i.Destination.ArrTime.split(
																							'T'
																						)[0];
																					})
																			: ''
																		: item.Supplier === 'ETR'
																		? item.Segments.length === 1
																			? item.Segments.filter(
																					(i, index) => index === 0
																			  ).map((it) => {
																					return it.Arrival_DateTime.split(
																						' '
																					)[0];
																			  })
																			: item.Segments.length === 2
																			? item.Segments.filter(
																					(i, index) => index === 1
																			  ).map((it) => {
																					return it.Arrival_DateTime.split(
																						' '
																					)[0];
																			  })
																			: item.Segments.length === 3
																			? item.Segments.filter(
																					(i, index) => index === 2
																			  ).map((it) => {
																					return it.Arrival_DateTime.split(
																						' '
																					)[0];
																			  })
																			: ''
																		: item.Supplier === 'TJK'
																		? item.sI.length === 1
																			? item.sI
																					.filter((i, index) => index === 0)
																					.map((it) => {
																						return it.at.split('T')[0];
																					})
																			: item.sI.length === 2
																			? item.sI
																					.filter((i, index) => index === 1)
																					.map((it) => {
																						return it.at.split('T')[0];
																					})
																			: item.sI.length === 3
																			? item.sI
																					.filter((i, index) => index === 2)
																					.map((it) => {
																						return it.at.split('T')[0];
																					})
																			: ''
																		: ''
																).getDate()} ${new Date(
																	item.AirlineCode
																		? item.Segments[1].length == 3
																			? item.Segments[1]
																					.filter((i, index) => index === 2)
																					.map((i) => {
																						return i.Destination.ArrTime.split(
																							'T'
																						)[0];
																					})
																			: item.Segments[1].length == 2
																			? item.Segments[1]
																					.filter((i, index) => index === 1)
																					.map((i) => {
																						return i.Destination.ArrTime.split(
																							'T'
																						)[0];
																					})
																			: item.Segments[1].length == 1
																			? item.Segments[1]
																					.filter((i, index) => index === 0)
																					.map((i) => {
																						return i.Destination.ArrTime.split(
																							'T'
																						)[0];
																					})
																			: ''
																		: item.Supplier === 'ETR'
																		? item.Segments.length === 1
																			? item.Segments.filter(
																					(i, index) => index === 0
																			  ).map((it) => {
																					return it.Arrival_DateTime.split(
																						' '
																					)[0];
																			  })
																			: item.Segments.length === 2
																			? item.Segments.filter(
																					(i, index) => index === 1
																			  ).map((it) => {
																					return it.Arrival_DateTime.split(
																						' '
																					)[0];
																			  })
																			: item.Segments.length === 3
																			? item.Segments.filter(
																					(i, index) => index === 2
																			  ).map((it) => {
																					return it.Arrival_DateTime.split(
																						' '
																					)[0];
																			  })
																			: ''
																		: item.Supplier === 'TJK'
																		? item.sI.length === 1
																			? item.sI
																					.filter((i, index) => index === 0)
																					.map((it) => {
																						return it.at.split('T')[0];
																					})
																			: item.sI.length === 2
																			? item.sI
																					.filter((i, index) => index === 1)
																					.map((it) => {
																						return it.at.split('T')[0];
																					})
																			: item.sI.length === 3
																			? item.sI
																					.filter((i, index) => index === 2)
																					.map((it) => {
																						return it.at.split('T')[0];
																					})
																			: ''
																		: ''
																).toLocaleString('en-us', {
																	month: 'short',
																})}`}
															</span>
														</Box>
														<h4>
															₹
															{item.Supplier === 'TBO'
																? Number(
																		Math.round(
																			Number(
																				Number(
																					Math.round(item.Fare.Total_Amount)
																				) -
																					Number(
																						Math.round(item.Fare.MFB_Discount)
																					)
																			)
																		)
																  )
																: item.Supplier === 'ETR'
																? Number(
																		Math.round(
																			Number(
																				Number(
																					Math.round(item.Fares.Total_Amount)
																				)
																			)
																		)
																  )
																: item.Supplier === 'TJK'
																? Number(
																		Math.round(
																			Number(
																				Number(
																					Math.round(
																						item.totalPriceList.fd.Total_Amount
																					)
																				)
																			)
																		)
																  )
																: ''}
														</h4>
													</Box>
												</Grid>
											</Grid>
										</>
									) : (
										Array.from(Array(10)).map((i) => {
											return <FlightRoundTripSkeleton />;
										})
									);
								})}
							</InfiniteScroll>
						) : (
							Array.from(Array(10)).map((i) => {
								return <FlightRoundTripSkeleton />;
							})
						)}
					</Grid>
					<Grid item xs={4}>
						<Box>
							<img src='https://tpc.googlesyndication.com/simgad/16156858053234787891?sqp=4sqPyQQrQikqJwhfEAEdAAC0QiABKAEwCTgDQPCTCUgAUAFYAWBfcAJ4AcUBLbKdPg&rs=AOga4qmd7sh5rWiWjxdzaN9vw44WnXQdZA' />
						</Box>
					</Grid>
				</Grid>
			</Box>
			{onwardFlight ? (
				<Box
					style={{
						position: 'fixed',
						bottom: 0,
						left: 0,
						right: 0,
						padding: '10px 50px',
						background: 'white',
						zIndex: 9,
					}}>
					<Box
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
						}}>
						<Box style={{ display: 'flex', alignItems: 'center' }}>
							<img
								src={`https://nitish.musafirbazar.com/static/media/${
									onwardFlight?.Supplier === 'TBO'
										? onwardFlight?.AirlineCode
										: onwardFlight?.Supplier === 'ETR'
										? onwardFlight?.Airline_Code
										: onwardFlight?.Supplier === 'TJK'
										? onwardFlight?.sI[0].fD.aI.code
										: ''
								}.gif`}
								style={{ height: 50 }}
							/>
							<Box ml={2}>
								<span style={{ fontSize: 12 }}>
									{onwardFlight?.Supplier === 'TBO'
										? onwardFlight.Segments[0].slice(0, 1).map((i) => {
												return i.Airline.AirlineName;
										  })
										: onwardFlight?.Supplier === 'ETR'
										? onwardFlight.Segments[0].Airline_Name
										: onwardFlight?.Supplier === 'TJK'
										? onwardFlight.sI[0].fD.aI.name
										: ''}
								</span>{' '}
								<br></br>
								<span style={{ fontSize: 12 }}>{`${
									onwardFlight?.Supplier === 'TBO'
										? onwardFlight.AirlineCode
										: onwardFlight?.Supplier === 'ETR'
										? onwardFlight?.Airline_Code
										: onwardFlight?.Supplier === 'TJK'
										? onwardFlight?.sI[0].fD.aI.code
										: ''
								}${
									onwardFlight?.Supplier === 'TBO'
										? onwardFlight.Segments[0].slice(0, 1).map((i) => {
												return i.Airline.FlightNumber;
										  })
										: onwardFlight?.Supplier === 'ETR'
										? onwardFlight.Segments[0].Flight_Number
										: onwardFlight?.Supplier === 'TJK'
										? onwardFlight.sI[0].fD.fN
										: ''
								}`}</span>
							</Box>
							<Box ml={2}>
								<span style={{ fontSize: 16, fontWeight: 'bold' }}>
									{`${
										onwardFlight?.Supplier === 'TBO'
											? onwardFlight.FareRules[0].Origin
											: onwardFlight?.Supplier === 'ETR'
											? onwardFlight.Origin
											: onwardFlight?.Supplier === 'TJK'
											? onwardFlight.sI[0].da.code
											: ''
									} ${
										onwardFlight?.Supplier === 'TBO'
											? onwardFlight.Segments[0].slice(0, 1).map((i) => {
													return i.Origin.DepTime.substr(11, 5);
											  })
											: onwardFlight?.Supplier === 'ETR'
											? onwardFlight.Segments[0].Departure_DateTime.split(
													' '
											  )[1]
											: onwardFlight?.Supplier === 'TJK'
											? onwardFlight.sI[0].dt.substr(11, 5)
											: ''
									}`}
								</span>
								<br></br>
							</Box>
							<ArrowForwardIcon style={{ marginLeft: 5, marginRight: 5 }} />

							<Box ml={2}>
								<span style={{ fontSize: 16, fontWeight: 'bold' }}>
									{`${
										onwardFlight?.Supplier === 'TBO'
											? onwardFlight.Segments[0].length == 2
												? onwardFlight.Segments[0]
														.filter((i, index) => index === 1)
														.map((it) => {
															return it.Destination.Airport.AirportCode;
														})
												: onwardFlight.Segments[0].length == 3
												? onwardFlight.Segments[0]
														.filter((i, index) => index === 2)
														.map((it) => {
															return it.Destination.Airport.AirportCode;
														})
												: onwardFlight.Segments[0].length == 1
												? onwardFlight.Segments[0].map((it) => {
														return it.Destination.Airport.AirportCode;
												  })
												: ''
											: onwardFlight?.Supplier === 'ETR'
											? onwardFlight.Destination
											: onwardFlight?.Supplier === 'TJK'
											? onwardFlight.sI.length === 1
												? onwardFlight.sI
														.filter((i, index) => index === 0)
														.map((it) => {
															return it.aa.cityCode;
														})
												: onwardFlight.sI.length === 2
												? onwardFlight.sI
														.filter((i, index) => index === 1)
														.map((it) => {
															return it.aa.cityCode;
														})
												: onwardFlight.sI.length === 3
												? onwardFlight.sI
														.filter((i, index) => index === 2)
														.map((it) => {
															return it.aa.cityCode;
														})
												: ''
											: ''
									} ${
										onwardFlight?.Supplier === 'TBO'
											? onwardFlight.Segments[0].length == 3
												? onwardFlight.Segments[0]
														.filter((i, index) => index === 2)
														.map((i) => {
															return i.Destination.ArrTime.substr(11, 5);
														})
												: onwardFlight.Segments[0].length == 2
												? onwardFlight.Segments[0]
														.filter((i, index) => index === 1)
														.map((i) => {
															return i.Destination.ArrTime.substr(11, 5);
														})
												: onwardFlight.Segments[0].length == 1
												? onwardFlight.Segments[0]
														.filter((i, index) => index === 0)
														.map((i) => {
															return i.Destination.ArrTime.substr(11, 5);
														})
												: ''
											: onwardFlight?.Supplier === 'ETR'
											? onwardFlight.Segments.length === 1
												? onwardFlight.Segments.filter(
														(i, index) => index === 0
												  ).map((it) => {
														return it.Arrival_DateTime.substr(11, 5);
												  })
												: onwardFlight.Segments.length === 2
												? onwardFlight.Segments.filter(
														(i, index) => index === 1
												  ).map((it) => {
														return it.Arrival_DateTime.substr(11, 5);
												  })
												: onwardFlight.Segments.length === 3
												? onwardFlight.Segments.filter(
														(i, index) => index === 2
												  ).map((it) => {
														return it.Arrival_DateTime.substr(11, 5);
												  })
												: ''
											: onwardFlight.Supplier === 'TJK'
											? onwardFlight.sI.length === 1
												? onwardFlight.sI
														.filter((i, index) => index === 0)
														.map((it) => {
															return it.at.substr(11, 5);
														})
												: onwardFlight.sI.length === 2
												? onwardFlight.sI
														.filter((i, index) => index === 1)
														.map((it) => {
															return it.at.substr(11, 5);
														})
												: onwardFlight.sI.length === 3
												? onwardFlight.sI
														.filter((i, index) => index === 2)
														.map((it) => {
															return it.at.substr(11, 5);
														})
												: ''
											: ''
									}`}
								</span>
								<br></br>
								<span style={{ fontSize: 12 }}>
									{onwardFlight?.Supplier === 'TBO'
										? onwardFlight.Segments[0].length === 1
											? 'Non Stop'
											: onwardFlight.Segments[0].length === 2
											? '1 Stop'
											: onwardFlight.Segments[0].length === 3
											? '2 Stop'
											: ''
										: onwardFlight?.Supplier === 'ETR'
										? onwardFlight.Segments.length === 1
											? 'Non Stop'
											: onwardFlight.Segments.length === 2
											? '1 Stop'
											: onwardFlight.Segments.length === 3
											? '2 Stop'
											: ''
										: onwardFlight?.Supplier === 'TJK'
										? onwardFlight.sI.length === 1
											? 'Non Stop'
											: onwardFlight.sI.length === 2
											? '1 Stop'
											: onwardFlight.sI.length === 3
											? '2 Stop'
											: ''
										: ''}
								</span>
							</Box>
							<h3 style={{ marginLeft: 20 }}>
								{/* ₹
								{onwardFlight.Supplier === 'TBO'
									? Number(
											Math.round(
												Number(
													Number(Math.round(onwardFlight.Fare.Total_Amount)) -
														Number(Math.round(onwardFlight.Fare.MFB_Discount))
												)
											)
									  )
									: onwardFlight.Supplier === 'ETR'
									? Number(
											Math.round(
												Number(
													Number(Math.round(onwardFlight.Fares.Total_Amount))
												)
											)
									  )
									: onwardFlight.Supplier === 'TJK'
									? Number(
											Math.round(
												Number(
													Number(
														Math.round(
															onwardFlight.totalPriceList.fd.Total_Amount
														)
													)
												)
											)
									  )
									: ''} */}
							</h3>
						</Box>
						<Box style={{ display: 'flex', alignItems: 'center' }}>
							<img
								src={`https://nitish.musafirbazar.com/static/media/${
									onwardFlight?.Supplier === 'TBO'
										? onwardFlight?.AirlineCode
										: onwardFlight?.Supplier === 'ETR'
										? onwardFlight?.Airline_Code
										: onwardFlight?.Supplier === 'TJK'
										? onwardFlight?.sI[0].fD.aI.code
										: ''
								}.gif`}
								style={{ height: 50 }}
							/>
							<Box ml={2}>
								<span style={{ fontSize: 12 }}>
									{onwardFlight?.Supplier === 'TBO'
										? onwardFlight.Segments[1].slice(0, 1).map((i) => {
												return i.Airline.AirlineName;
										  })
										: onwardFlight?.Supplier === 'ETR'
										? onwardFlight.Segments[0].Airline_Name
										: onwardFlight?.Supplier === 'TJK'
										? onwardFlight.sI[0].fD.aI.name
										: ''}
								</span>{' '}
								<br></br>
								<span style={{ fontSize: 12 }}>{`${
									onwardFlight?.Supplier === 'TBO'
										? onwardFlight.AirlineCode
										: onwardFlight?.Supplier === 'ETR'
										? onwardFlight?.Airline_Code
										: onwardFlight?.Supplier === 'TJK'
										? onwardFlight?.sI[0].fD.aI.code
										: ''
								}${
									onwardFlight?.Supplier === 'TBO'
										? onwardFlight.Segments[0].slice(0, 1).map((i) => {
												return i.Airline.FlightNumber;
										  })
										: onwardFlight?.Supplier === 'ETR'
										? onwardFlight.Segments[0].Flight_Number
										: onwardFlight?.Supplier === 'TJK'
										? onwardFlight.sI[0].fD.fN
										: ''
								}`}</span>
							</Box>
							<Box ml={2}>
								<span style={{ fontSize: 16, fontWeight: 'bold' }}>
									{`${
										onwardFlight?.Supplier === 'TBO'
											? onwardFlight.FareRules[1].Origin
											: onwardFlight?.Supplier === 'ETR'
											? onwardFlight.Origin
											: onwardFlight?.Supplier === 'TJK'
											? onwardFlight.sI[0].da.code
											: ''
									} ${
										onwardFlight?.Supplier === 'TBO'
											? onwardFlight.Segments[1].slice(0, 1).map((i) => {
													return i.Origin.DepTime.substr(11, 5);
											  })
											: onwardFlight?.Supplier === 'ETR'
											? onwardFlight.Segments[0].Departure_DateTime.split(
													' '
											  )[1]
											: onwardFlight?.Supplier === 'TJK'
											? onwardFlight.sI[0].dt.substr(11, 5)
											: ''
									}`}
								</span>
								<br></br>
							</Box>
							<ArrowForwardIcon style={{ marginLeft: 5, marginRight: 5 }} />

							<Box ml={2}>
								<span style={{ fontSize: 16, fontWeight: 'bold' }}>
									{`${
										onwardFlight?.Supplier === 'TBO'
											? onwardFlight.Segments[1].length == 2
												? onwardFlight.Segments[1]
														.filter((i, index) => index === 1)
														.map((it) => {
															return it.Destination.Airport.AirportCode;
														})
												: onwardFlight.Segments[1].length == 3
												? onwardFlight.Segments[1]
														.filter((i, index) => index === 2)
														.map((it) => {
															return it.Destination.Airport.AirportCode;
														})
												: onwardFlight.Segments[1].length == 1
												? onwardFlight.Segments[1].map((it) => {
														return it.Destination.Airport.AirportCode;
												  })
												: ''
											: onwardFlight?.Supplier === 'ETR'
											? onwardFlight.Destination
											: onwardFlight?.Supplier === 'TJK'
											? onwardFlight.sI.length === 1
												? onwardFlight.sI
														.filter((i, index) => index === 0)
														.map((it) => {
															return it.aa.cityCode;
														})
												: onwardFlight.sI.length === 2
												? onwardFlight.sI
														.filter((i, index) => index === 1)
														.map((it) => {
															return it.aa.cityCode;
														})
												: onwardFlight.sI.length === 3
												? onwardFlight.sI
														.filter((i, index) => index === 2)
														.map((it) => {
															return it.aa.cityCode;
														})
												: ''
											: ''
									} ${
										onwardFlight?.Supplier === 'TBO'
											? onwardFlight.Segments[1].length == 3
												? onwardFlight.Segments[1]
														.filter((i, index) => index === 2)
														.map((i) => {
															return i.Destination.ArrTime.substr(11, 5);
														})
												: onwardFlight.Segments[1].length == 2
												? onwardFlight.Segments[1]
														.filter((i, index) => index === 1)
														.map((i) => {
															return i.Destination.ArrTime.substr(11, 5);
														})
												: onwardFlight.Segments[1].length == 1
												? onwardFlight.Segments[1]
														.filter((i, index) => index === 0)
														.map((i) => {
															return i.Destination.ArrTime.substr(11, 5);
														})
												: ''
											: onwardFlight?.Supplier === 'ETR'
											? onwardFlight.Segments.length === 1
												? onwardFlight.Segments.filter(
														(i, index) => index === 0
												  ).map((it) => {
														return it.Arrival_DateTime.substr(11, 5);
												  })
												: onwardFlight.Segments.length === 2
												? onwardFlight.Segments.filter(
														(i, index) => index === 1
												  ).map((it) => {
														return it.Arrival_DateTime.substr(11, 5);
												  })
												: onwardFlight.Segments.length === 3
												? onwardFlight.Segments.filter(
														(i, index) => index === 2
												  ).map((it) => {
														return it.Arrival_DateTime.substr(11, 5);
												  })
												: ''
											: onwardFlight.Supplier === 'TJK'
											? onwardFlight.sI.length === 1
												? onwardFlight.sI
														.filter((i, index) => index === 0)
														.map((it) => {
															return it.at.substr(11, 5);
														})
												: onwardFlight.sI.length === 2
												? onwardFlight.sI
														.filter((i, index) => index === 1)
														.map((it) => {
															return it.at.substr(11, 5);
														})
												: onwardFlight.sI.length === 3
												? onwardFlight.sI
														.filter((i, index) => index === 2)
														.map((it) => {
															return it.at.substr(11, 5);
														})
												: ''
											: ''
									}`}
								</span>
								<br></br>
								<span style={{ fontSize: 12 }}>
									{onwardFlight?.Supplier === 'TBO'
										? onwardFlight.Segments[1].length === 1
											? 'Non Stop'
											: onwardFlight.Segments[1].length === 2
											? '1 Stop'
											: onwardFlight.Segments[1].length === 3
											? '2 Stop'
											: ''
										: onwardFlight?.Supplier === 'ETR'
										? onwardFlight.Segments.length === 1
											? 'Non Stop'
											: onwardFlight.Segments.length === 2
											? '1 Stop'
											: onwardFlight.Segments.length === 3
											? '2 Stop'
											: ''
										: onwardFlight?.Supplier === 'TJK'
										? onwardFlight.sI.length === 1
											? 'Non Stop'
											: onwardFlight.sI.length === 2
											? '1 Stop'
											: onwardFlight.sI.length === 3
											? '2 Stop'
											: ''
										: ''}
								</span>
							</Box>
						</Box>
						<Box style={{ display: 'flex', alignItems: 'center' }}>
							<h1 style={{ marginLeft: 20, fontSize: 26 }}>
								₹
								{onwardFlight.Supplier === 'TBO'
									? Number(
											Math.round(
												Number(
													Number(Math.round(onwardFlight.Fare.Total_Amount)) -
														Number(Math.round(onwardFlight.Fare.MFB_Discount))
												)
											)
									  )
									: onwardFlight.Supplier === 'ETR'
									? Number(
											Math.round(
												Number(
													Number(Math.round(onwardFlight.Fares.Total_Amount))
												)
											)
									  )
									: onwardFlight.Supplier === 'TJK'
									? Number(
											Math.round(
												Number(
													Number(
														Math.round(
															onwardFlight.totalPriceList.fd.Total_Amount
														)
													)
												)
											)
									  )
									: ''}
							</h1>
							<Button
								onClick={() =>
									navigate('/flightbooking', {
										state: {
											onward: onwardFlight,
											formData: location.state,
										},
									})
								}
								style={{
									background: '#EC5B24',
									color: 'white',
									fontWeight: 'bold',
									marginLeft: 10,
								}}>
								Book
							</Button>
						</Box>
					</Box>
				</Box>
			) : (
				''
			)}
			<TopDrawer
				draw={draw}
				setDraw={setDraw}
				filterAirlineTBO={filterAirlineCom}
				airlineS={airlineS}
				handleAirline={handleAirline}
				handleFareType={handleFareType}
				handleStopType={handleStopType}
				fare={fare}
				stop={stop}
			/>
			<Footer />
		</div>
	);
};

export default SearchResultInternational;
